// @ts-nocheck
import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>
}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>
}
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T
> = { [_ in K]?: never }
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never
    }
const defaultOptions = {} as const
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  Cursor: { input: any; output: any }
  Date: { input: any; output: any }
}

export type Account = {
  __typename: 'Account'
  disconnectedAt?: Maybe<Scalars['String']['output']>
  hasAchAccountNumber?: Maybe<Scalars['Boolean']['output']>
  hasAchRoutingNumber?: Maybe<Scalars['Boolean']['output']>
  hasWireRoutingNumber?: Maybe<Scalars['Boolean']['output']>
  id: Scalars['ID']['output']
  institution?: Maybe<Institution>
  mask?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  officialName?: Maybe<Scalars['String']['output']>
  provider?: Maybe<Scalars['String']['output']>
  subtype?: Maybe<Scalars['String']['output']>
  systemDeactivatedAt?: Maybe<Scalars['String']['output']>
  type?: Maybe<Scalars['String']['output']>
}

export type Address = AddressInterface & {
  __typename: 'Address'
  city?: Maybe<Scalars['String']['output']>
  country?: Maybe<Scalars['String']['output']>
  postalCode?: Maybe<Scalars['String']['output']>
  state?: Maybe<Scalars['String']['output']>
  streetAddress?: Maybe<Scalars['String']['output']>
  subPremise?: Maybe<Scalars['String']['output']>
}

export type AddressInput = {
  city?: InputMaybe<Scalars['String']['input']>
  country?: InputMaybe<Scalars['String']['input']>
  postalCode?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['String']['input']>
  streetAddress?: InputMaybe<Scalars['String']['input']>
  subPremise?: InputMaybe<Scalars['String']['input']>
}

export type AddressInterface = {
  city?: Maybe<Scalars['String']['output']>
  country?: Maybe<Scalars['String']['output']>
  postalCode?: Maybe<Scalars['String']['output']>
  state?: Maybe<Scalars['String']['output']>
  streetAddress?: Maybe<Scalars['String']['output']>
  subPremise?: Maybe<Scalars['String']['output']>
}

export type AutopayExcludedCustomer = {
  __typename: 'AutopayExcludedCustomer'
  createdByCustomer: Scalars['Boolean']['output']
  customer: Customer
  id: Scalars['ID']['output']
  partnerID: Scalars['ID']['output']
}

export type AutopayRule = {
  __typename: 'AutopayRule'
  amount?: Maybe<Scalars['Float']['output']>
  amountOperator?: Maybe<RuleOperator>
  autotaskContractTypes?: Maybe<Array<AutotaskContractType>>
  connectwiseAgreementTypes?: Maybe<Array<ConnectwiseAgreementType>>
  createdByCustomer: Scalars['Boolean']['output']
  customers?: Maybe<Array<Maybe<Customer>>>
  daysBeforeDue?: Maybe<Scalars['Int']['output']>
  daysPastCreation?: Maybe<Scalars['Int']['output']>
  daysPastDue?: Maybe<Scalars['Int']['output']>
  haloPSAContractSubtypes?: Maybe<Array<HaloPsaContractSubtype>>
  halopsaRecurringInvoices?: Maybe<Scalars['Boolean']['output']>
  id: Scalars['ID']['output']
  partnerID: Scalars['ID']['output']
  quickbooksRecurringTransactions?: Maybe<Array<QuickbooksRecurringTransaction>>
}

/** A connection to a list of items. */
export type AutopayRuleConnection = {
  __typename: 'AutopayRuleConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AutopayRuleEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type AutopayRuleEdge = {
  __typename: 'AutopayRuleEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output']
  /** The item at the end of the edge. */
  node?: Maybe<AutopayRule>
}

export type AutopayRuleOrderBy = {
  direction?: InputMaybe<OrderDirection>
  field?: InputMaybe<AutopayRuleOrderByField>
}

export enum AutopayRuleOrderByField {
  DaysPastDue = 'DAYS_PAST_DUE'
}

export type AutotaskContractType = {
  __typename: 'AutotaskContractType'
  externalID: Scalars['String']['output']
  name: Scalars['String']['output']
  partnerID: Scalars['String']['output']
}

export type BnplCreateInput = {
  accountID: Scalars['String']['input']
  invoiceID: Scalars['String']['input']
  term: Scalars['Int']['input']
}

export type BnplGetRateInput = {
  amount: Scalars['Float']['input']
  term: Scalars['Int']['input']
}

export type BnplOffer = {
  __typename: 'BNPLOffer'
  amount: Scalars['Float']['output']
  approved: Scalars['Boolean']['output']
  approvedBy?: Maybe<SuperAdminUser>
  createdAt: Scalars['String']['output']
  customer?: Maybe<Customer>
  fees: Scalars['Float']['output']
  id: Scalars['ID']['output']
  invoiceID: Scalars['ID']['output']
  netAmount: Scalars['Float']['output']
  partner?: Maybe<Partner>
  partnerConfirmed: Scalars['Boolean']['output']
  rate: Scalars['Float']['output']
  remainingBalance: Scalars['Float']['output']
  status: BnplStatus
  terms: Scalars['Int']['output']
}

export type BnplRateResult = {
  __typename: 'BNPLRateResult'
  amount: Scalars['Float']['output']
  fees: Scalars['Float']['output']
  installment: Scalars['Float']['output']
  netAmount: Scalars['Float']['output']
  rate: Scalars['Float']['output']
  term: Scalars['Int']['output']
}

export enum BnplStatus {
  Creating = 'CREATING',
  Failed = 'FAILED',
  Inprocess = 'INPROCESS',
  Inreview = 'INREVIEW',
  Rejected = 'REJECTED'
}

export type BnplFilter = {
  approved?: InputMaybe<Scalars['Boolean']['input']>
  createdAtEnd?: InputMaybe<Scalars['String']['input']>
  createdAtStart?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<Array<BnplStatus>>
}

export type Card = {
  __typename: 'Card'
  cardNetWork: CardNetwork
  expirationDate: Scalars['String']['output']
  id: Scalars['ID']['output']
  last4: Scalars['String']['output']
  systemDeactivatedAt?: Maybe<Scalars['String']['output']>
}

export type CardCreationInput = {
  billingAddress?: InputMaybe<AddressInput>
  cardProviderToken: Scalars['String']['input']
  provider: CardProvider
}

export type CardDeletionInput = {
  id: Scalars['ID']['input']
}

export type CardFeeAmount = {
  __typename: 'CardFeeAmount'
  feeAmount: Scalars['Float']['output']
  percentage: Scalars['Float']['output']
}

export enum CardNetwork {
  AmericanExpress = 'AMERICAN_EXPRESS',
  DinersClub = 'DINERS_CLUB',
  Discover = 'DISCOVER',
  Mastercard = 'MASTERCARD',
  Other = 'OTHER',
  Visa = 'VISA'
}

export enum CardProvider {
  Checkout = 'CHECKOUT',
  Modernbanc = 'MODERNBANC'
}

export type CardSerializationInput = {
  cardHolderNameSecretID: Scalars['String']['input']
  expirationDateSecretID: Scalars['String']['input']
  panSecretID: Scalars['String']['input']
}

export enum CompanyType {
  Alternative = 'ALTERNATIVE',
  Customer = 'CUSTOMER',
  Partner = 'PARTNER'
}

export type CompanyUnion = Customer | Partner

export type ConnectwiseAgreementType = {
  __typename: 'ConnectwiseAgreementType'
  externalID: Scalars['String']['output']
  name: Scalars['String']['output']
  partnerID: Scalars['String']['output']
}

export type CoverFeeConfig = {
  __typename: 'CoverFeeConfig'
  coverACHMethodFee?: Maybe<Scalars['Boolean']['output']>
  coverCardMethodFee?: Maybe<Scalars['Boolean']['output']>
  coverOtherMethodFee?: Maybe<Scalars['Boolean']['output']>
  coverWireMethodFee?: Maybe<Scalars['Boolean']['output']>
}

export type Customer = AddressInterface & {
  __typename: 'Customer'
  archivedBy?: Maybe<Scalars['String']['output']>
  city?: Maybe<Scalars['String']['output']>
  companyType?: Maybe<Scalars['String']['output']>
  country?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['String']['output']
  description?: Maybe<Scalars['String']['output']>
  ein?: Maybe<Scalars['String']['output']>
  feeConfig?: Maybe<Array<Maybe<CustomerFeeConfig>>>
  id: Scalars['ID']['output']
  industry?: Maybe<Scalars['String']['output']>
  isArchived: Scalars['Boolean']['output']
  isOnboarded: Scalars['Boolean']['output']
  legalName?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  partner?: Maybe<Partner>
  postalCode?: Maybe<Scalars['String']['output']>
  state?: Maybe<Scalars['String']['output']>
  streetAddress?: Maybe<Scalars['String']['output']>
  subPremise?: Maybe<Scalars['String']['output']>
}

export type CustomerCardFeeDetail = {
  __typename: 'CustomerCardFeeDetail'
  cardNetwork: CardNetwork
  percentage: Scalars['Float']['output']
}

export type CustomerCreateAutopayRuleInput = {
  amount?: InputMaybe<Scalars['Float']['input']>
  amountOperator?: InputMaybe<RuleOperator>
}

export type CustomerFeeConfig = {
  __typename: 'CustomerFeeConfig'
  customer: Customer
  feeType: FeeExceptionType
  id: Scalars['ID']['output']
  partner: Partner
}

export type CustomerForwardingConfig = {
  __typename: 'CustomerForwardingConfig'
  coverDirectPaymentFees: Scalars['Boolean']['output']
  coverFeeConfig?: Maybe<CoverFeeConfig>
  customer: Customer
  partner: Partner
}

export type CustomerGetUserInfoReply = {
  __typename: 'CustomerGetUserInfoReply'
  id: Scalars['ID']['output']
  userType: UserType
  users?: Maybe<Array<CustomerUserInfo>>
}

export type CustomerInviteUserInput = {
  email: Scalars['String']['input']
  firstName?: InputMaybe<Scalars['String']['input']>
  jobTitle?: InputMaybe<Scalars['String']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
}

export type CustomerInvoiceCreateInput = {
  amount: Scalars['Float']['input']
  dueDate?: InputMaybe<Scalars['String']['input']>
  partnerId: Scalars['String']['input']
  productName?: InputMaybe<Scalars['String']['input']>
}

export type CustomerUpdateAddressInput = {
  city: Scalars['String']['input']
  country: Scalars['String']['input']
  postalCode: Scalars['String']['input']
  state: Scalars['String']['input']
  streetAddress: Scalars['String']['input']
  subPremise?: InputMaybe<Scalars['String']['input']>
}

export type CustomerUpdateAutopayRuleInput = {
  amount?: InputMaybe<Scalars['Float']['input']>
  amountOperator?: InputMaybe<RuleOperator>
  id: Scalars['ID']['input']
}

export type CustomerUpdateDetailsInput = {
  companyType: Scalars['String']['input']
  description?: InputMaybe<Scalars['String']['input']>
  ein?: InputMaybe<Scalars['String']['input']>
  industry: Scalars['String']['input']
  legalName: Scalars['String']['input']
  name: Scalars['String']['input']
}

export type CustomerUpdateMyUserInput = {
  firstName?: InputMaybe<Scalars['String']['input']>
  jobTitle?: InputMaybe<Scalars['String']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
}

export type CustomerUpdateUserInput = {
  firstName?: InputMaybe<Scalars['String']['input']>
  id: Scalars['String']['input']
  jobTitle?: InputMaybe<Scalars['String']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
}

export type CustomerUser = {
  __typename: 'CustomerUser'
  createdAt: Scalars['String']['output']
  email: Scalars['String']['output']
  firstName?: Maybe<Scalars['String']['output']>
  hasMFA?: Maybe<Scalars['Boolean']['output']>
  id: Scalars['ID']['output']
  jobTitle?: Maybe<Scalars['String']['output']>
  lastName?: Maybe<Scalars['String']['output']>
  phone?: Maybe<Scalars['String']['output']>
  role: CustomerUserRole
}

/** A connection to a list of items. */
export type CustomerUserConnection = {
  __typename: 'CustomerUserConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CustomerUserEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type CustomerUserEdge = {
  __typename: 'CustomerUserEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output']
  /** The item at the end of the edge. */
  node?: Maybe<CustomerUser>
}

export type CustomerUserInfo = {
  __typename: 'CustomerUserInfo'
  createdAt: Scalars['String']['output']
  customer?: Maybe<Customer>
  email: Scalars['String']['output']
  firstName?: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  jobTitle?: Maybe<Scalars['String']['output']>
  lastName?: Maybe<Scalars['String']['output']>
  permissions: Array<CustomerUserPermissions>
  phone?: Maybe<Scalars['String']['output']>
  role: Scalars['String']['output']
}

export type CustomerUserOrderBy = {
  direction?: InputMaybe<OrderDirection>
  field?: InputMaybe<CustomerUserOrderByField>
}

export enum CustomerUserOrderByField {
  Name = 'NAME'
}

export enum CustomerUserPermissions {
  AutopayConfigList = 'AUTOPAY_CONFIG_LIST',
  AutopayRuleCreate = 'AUTOPAY_RULE_CREATE',
  AutopayRuleList = 'AUTOPAY_RULE_LIST',
  BankingDelete = 'BANKING_DELETE',
  BankingGetintegration = 'BANKING_GETINTEGRATION',
  BankingNew = 'BANKING_NEW',
  BankingUpdate = 'BANKING_UPDATE',
  BnplCreate = 'BNPL_CREATE',
  CardtransferList = 'CARDTRANSFER_LIST',
  CardList = 'CARD_LIST',
  CardManage = 'CARD_MANAGE',
  CustomeruserCreate = 'CUSTOMERUSER_CREATE',
  CustomeruserDelete = 'CUSTOMERUSER_DELETE',
  CustomeruserList = 'CUSTOMERUSER_LIST',
  CustomeruserUpdate = 'CUSTOMERUSER_UPDATE',
  CustomeruserUpdateMyself = 'CUSTOMERUSER_UPDATE_MYSELF',
  CustomerUpdate = 'CUSTOMER_UPDATE',
  DirectpaymentPay = 'DIRECTPAYMENT_PAY',
  InvoiceCreate = 'INVOICE_CREATE',
  InvoiceDownload = 'INVOICE_DOWNLOAD',
  InvoiceList = 'INVOICE_LIST',
  LendingPay = 'LENDING_PAY',
  NotificationsRead = 'NOTIFICATIONS_READ',
  NotificationsUpdate = 'NOTIFICATIONS_UPDATE',
  PaymentcompanyconfigList = 'PAYMENTCOMPANYCONFIG_LIST',
  PaymentcompanyconfigUpdate = 'PAYMENTCOMPANYCONFIG_UPDATE',
  PaymentList = 'PAYMENT_LIST',
  SupportPreferencesGet = 'SUPPORT_PREFERENCES_GET'
}

export enum CustomerUserRole {
  Customer = 'CUSTOMER'
}

export type DirectPayment = {
  __typename: 'DirectPayment'
  amount: Scalars['Float']['output']
  createPayoutAsAnalyzing: Scalars['Boolean']['output']
  creationDate: Scalars['String']['output']
  customer: Customer
  dueDate: Scalars['String']['output']
  id: Scalars['ID']['output']
  netAmount: Scalars['Float']['output']
  partner: Partner
  payerEntity: CompanyType
  payments: Array<Maybe<Payment>>
  payoutCreationForecastDate?: Maybe<Scalars['String']['output']>
  product: Product
  status: DirectPaymentStatus
}

export type DirectPaymentCreationResponse = {
  __typename: 'DirectPaymentCreationResponse'
  id?: Maybe<Scalars['ID']['output']>
  message?: Maybe<Scalars['String']['output']>
}

export enum DirectPaymentPaymentMethodEnum {
  Ach = 'ACH',
  Card = 'CARD'
}

export type DirectPaymentPaymentMethodInput = {
  method: DirectPaymentPaymentMethodEnum
  methodReferenceID: Scalars['String']['input']
}

export enum DirectPaymentStatus {
  Canceled = 'CANCELED',
  Chargeback = 'CHARGEBACK',
  Creating = 'CREATING',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Refunded = 'REFUNDED',
  Scheduled = 'SCHEDULED',
  Succeeded = 'SUCCEEDED'
}

export type DownloadableInvoiceLink = {
  __typename: 'DownloadableInvoiceLink'
  expires_at?: Maybe<Scalars['String']['output']>
  invoiceId: Scalars['String']['output']
  status: DownloadableInvoiceStatus
  url?: Maybe<Scalars['String']['output']>
}

export enum DownloadableInvoiceStatus {
  Available = 'AVAILABLE',
  Expired = 'EXPIRED',
  Initialized = 'INITIALIZED',
  Pending = 'PENDING',
  Unavailable = 'UNAVAILABLE'
}

export enum FeeExceptionType {
  Ach = 'ACH',
  Card = 'CARD',
  Directpayment = 'DIRECTPAYMENT',
  Other = 'OTHER',
  Wire = 'WIRE'
}

export enum FeeType {
  LatePayment = 'LATE_PAYMENT',
  Method = 'METHOD',
  Product = 'PRODUCT'
}

export type GetCardFeeInput = {
  Amount: Scalars['Float']['input']
  CardID?: InputMaybe<Scalars['ID']['input']>
}

export type GetCardPubKey = {
  provider: CardProvider
}

export type GetCustomerUserPortals = {
  __typename: 'GetCustomerUserPortals'
  partner: Partner
  teams?: Maybe<Array<Customer>>
}

export type GetCustomerUserTeamsReply = {
  __typename: 'GetCustomerUserTeamsReply'
  id: Scalars['ID']['output']
  portals?: Maybe<Array<GetCustomerUserPortals>>
}

export type HaloPsaContractSubtype = {
  __typename: 'HaloPSAContractSubtype'
  externalID: Scalars['String']['output']
  name: Scalars['String']['output']
  partnerID: Scalars['String']['output']
}

export type Installment = {
  __typename: 'Installment'
  amount: Scalars['Float']['output']
  dueDate: Scalars['String']['output']
  fees: Array<Maybe<InstallmentFee>>
  id: Scalars['ID']['output']
  netAmount: Scalars['Float']['output']
  payments: Array<Maybe<Payment>>
  status: InstallmentStatus
}

export type InstallmentFee = {
  __typename: 'InstallmentFee'
  amount: Scalars['Float']['output']
  name: Scalars['String']['output']
  type: FeeType
}

export enum InstallmentStatus {
  Canceled = 'CANCELED',
  Overdue = 'OVERDUE',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Scheduled = 'SCHEDULED',
  Succeeded = 'SUCCEEDED'
}

export type InstantPayment = {
  __typename: 'InstantPayment'
  id: Scalars['ID']['output']
}

export type Institution = {
  __typename: 'Institution'
  accounts?: Maybe<Array<Maybe<Account>>>
  externalId?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  logo?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  plaidConnection?: Maybe<PlaidInstitutionConnectionStatus>
  /** @deprecated Use 'Account.Provider' instead */
  provider?: Maybe<Scalars['String']['output']>
  url?: Maybe<Scalars['String']['output']>
}

export type Invoice = {
  __typename: 'Invoice'
  amount: Scalars['Float']['output']
  createdAt: Scalars['String']['output']
  createdByCustomer: Scalars['Boolean']['output']
  customer?: Maybe<Customer>
  directPayment?: Maybe<DirectPayment>
  dueDate?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  invoiceNumber: Scalars['String']['output']
  lastRemindedAt?: Maybe<Scalars['String']['output']>
  lending?: Maybe<Lending>
  offer?: Maybe<BnplOffer>
  outstandingAmount: Scalars['Float']['output']
  partner?: Maybe<Partner>
  productName?: Maybe<Scalars['String']['output']>
  recurringpayment: Scalars['Boolean']['output']
  recurringpaymentID?: Maybe<Scalars['String']['output']>
  status: InvoiceStatus
}

/** A connection to a list of items. */
export type InvoiceBnplConnection = {
  __typename: 'InvoiceBnplConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<InvoiceBnplEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type InvoiceBnplEdge = {
  __typename: 'InvoiceBnplEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output']
  /** The item at the end of the edge. */
  node?: Maybe<Invoice>
}

export type InvoiceBnplTotals = {
  __typename: 'InvoiceBnplTotals'
  count: Scalars['Int']['output']
  invoiceAmount: Scalars['Float']['output']
  offerAmount: Scalars['Float']['output']
}

/** A connection to a list of items. */
export type InvoiceConnection = {
  __typename: 'InvoiceConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<InvoiceEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type InvoiceEdge = {
  __typename: 'InvoiceEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output']
  /** The item at the end of the edge. */
  node?: Maybe<Invoice>
}

export type InvoiceFilter = {
  amountEnd?: InputMaybe<Scalars['Float']['input']>
  /** @deprecated use amountEnd instead */
  amountMax?: InputMaybe<Scalars['Float']['input']>
  /** @deprecated use amountStart instead */
  amountMin?: InputMaybe<Scalars['Float']['input']>
  amountStart?: InputMaybe<Scalars['Float']['input']>
  createdDateEnd?: InputMaybe<Scalars['Date']['input']>
  createdDateStart?: InputMaybe<Scalars['Date']['input']>
  dueDateEnd?: InputMaybe<Scalars['Date']['input']>
  dueDateStart?: InputMaybe<Scalars['Date']['input']>
  emailUnsent?: InputMaybe<Scalars['Boolean']['input']>
  recurring?: InputMaybe<Scalars['Boolean']['input']>
  recurringpaymentID?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<Array<InputMaybe<InvoiceStatus>>>
}

export type InvoiceOrderBy = {
  direction?: InputMaybe<OrderDirection>
  field?: InputMaybe<InvoiceOrderByField>
}

export enum InvoiceOrderByField {
  Amount = 'AMOUNT',
  CreatedDate = 'CREATED_DATE',
  DueDate = 'DUE_DATE',
  ProductName = 'PRODUCT_NAME'
}

export type InvoicePdfLink = {
  __typename: 'InvoicePdfLink'
  expiresAt: Scalars['String']['output']
  url: Scalars['String']['output']
}

export enum InvoiceStatus {
  Archived = 'ARCHIVED',
  Overdue = 'OVERDUE',
  Paid = 'PAID',
  Received = 'RECEIVED',
  Upcoming = 'UPCOMING'
}

export type InvoiceTotals = {
  __typename: 'InvoiceTotals'
  amount: Scalars['Float']['output']
  count: Scalars['Int']['output']
}

export type Lending = {
  __typename: 'Lending'
  amount: Scalars['Float']['output']
  creationDate: Scalars['String']['output']
  customer: Customer
  id: Scalars['ID']['output']
  installments?: Maybe<Array<Maybe<Installment>>>
  netAmount: Scalars['Float']['output']
  partner: Partner
  payerEntity: CompanyType
  product: Product
}

export enum LendingPaymentMethodEnum {
  Ach = 'ACH',
  Card = 'CARD',
  SameDayAch = 'SAME_DAY_ACH'
}

export type LendingPaymentMethodInput = {
  method: LendingPaymentMethodEnum
  methodReferenceID: Scalars['String']['input']
}

export type ListCardsFilterInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export enum ManualAccountSubtypes {
  Checking = 'CHECKING',
  Savings = 'SAVINGS'
}

export enum ManualAccountTypes {
  Depository = 'DEPOSITORY'
}

export type ManualBankingAccountInformationInput = {
  accountNumber: Scalars['String']['input']
  institutionName: Scalars['String']['input']
  receiverName: Scalars['String']['input']
  routingNumber: Scalars['String']['input']
  subType: ManualAccountSubtypes
  type: ManualAccountTypes
  wireRoutingNumber?: InputMaybe<Scalars['String']['input']>
}

export enum MethodEnum {
  Card = 'CARD',
  Manual = 'MANUAL',
  SameDayAch = 'SAME_DAY_ACH',
  StandardAch = 'STANDARD_ACH'
}

export type Mutation = {
  __typename: 'Mutation'
  CustomerAddManualBankingConnection?: Maybe<Scalars['String']['output']>
  CustomerAddPlaidBankingConnection?: Maybe<Scalars['String']['output']>
  CustomerArchiveAccount: Scalars['String']['output']
  CustomerAutopayExcludedCustomerCreate?: Maybe<AutopayExcludedCustomer>
  CustomerBNPLOfferCreate?: Maybe<Scalars['String']['output']>
  CustomerBNPLOfferGetRate?: Maybe<BnplRateResult>
  CustomerChangePaymentConfig?: Maybe<Scalars['String']['output']>
  CustomerCreateAutopayRule?: Maybe<AutopayRule>
  CustomerCreateCard?: Maybe<Scalars['String']['output']>
  CustomerDeleteCard?: Maybe<Scalars['String']['output']>
  CustomerDeleteUser?: Maybe<Scalars['String']['output']>
  CustomerFinishOnboarding?: Maybe<Customer>
  CustomerInviteUser?: Maybe<CustomerUser>
  CustomerInvoiceCreate?: Maybe<Invoice>
  CustomerModernBancGenerateSerializedToken?: Maybe<Scalars['String']['output']>
  CustomerPayInvoice?: Maybe<DirectPaymentCreationResponse>
  CustomerPayOverdueInstallment?: Maybe<Scalars['String']['output']>
  CustomerRequestAccess: Scalars['String']['output']
  CustomerUpdateAddress?: Maybe<Customer>
  CustomerUpdateAutopayRule?: Maybe<AutopayRule>
  CustomerUpdateDetails?: Maybe<Customer>
  CustomerUpdateMyUser?: Maybe<CustomerUser>
  CustomerUpdateNotificationsEnabled: NotificationsEnabled
  CustomerUpdateUser?: Maybe<CustomerUser>
  OAuth2Exchange: TokenExchange
  OAuth2Refresh: TokenExchange
}

export type MutationCustomerAddManualBankingConnectionArgs = {
  accountInformation: ManualBankingAccountInformationInput
}

export type MutationCustomerAddPlaidBankingConnectionArgs = {
  accountIds: Array<Scalars['String']['input']>
  institutionId?: InputMaybe<Scalars['String']['input']>
  publicToken: Scalars['String']['input']
}

export type MutationCustomerArchiveAccountArgs = {
  accountID: Scalars['ID']['input']
}

export type MutationCustomerBnplOfferCreateArgs = {
  input?: InputMaybe<BnplCreateInput>
}

export type MutationCustomerBnplOfferGetRateArgs = {
  input?: InputMaybe<BnplGetRateInput>
}

export type MutationCustomerChangePaymentConfigArgs = {
  paymentConfig: PaymentCompanyConfigUpdateInput
}

export type MutationCustomerCreateAutopayRuleArgs = {
  input: CustomerCreateAutopayRuleInput
}

export type MutationCustomerCreateCardArgs = {
  input: CardCreationInput
}

export type MutationCustomerDeleteCardArgs = {
  input: CardDeletionInput
}

export type MutationCustomerDeleteUserArgs = {
  id: Scalars['String']['input']
}

export type MutationCustomerInviteUserArgs = {
  input?: InputMaybe<CustomerInviteUserInput>
}

export type MutationCustomerInvoiceCreateArgs = {
  input?: InputMaybe<CustomerInvoiceCreateInput>
}

export type MutationCustomerModernBancGenerateSerializedTokenArgs = {
  input: CardSerializationInput
}

export type MutationCustomerPayInvoiceArgs = {
  amount?: InputMaybe<Scalars['Float']['input']>
  invoiceID: Scalars['String']['input']
  paymentDate?: InputMaybe<Scalars['String']['input']>
  paymentMethod?: InputMaybe<DirectPaymentPaymentMethodInput>
}

export type MutationCustomerPayOverdueInstallmentArgs = {
  installmentID: Scalars['String']['input']
  newPaymentMethod?: InputMaybe<LendingPaymentMethodInput>
  retryLastPaymentMethod: Scalars['Boolean']['input']
}

export type MutationCustomerUpdateAddressArgs = {
  input?: InputMaybe<CustomerUpdateAddressInput>
}

export type MutationCustomerUpdateAutopayRuleArgs = {
  input: CustomerUpdateAutopayRuleInput
}

export type MutationCustomerUpdateDetailsArgs = {
  input?: InputMaybe<CustomerUpdateDetailsInput>
}

export type MutationCustomerUpdateMyUserArgs = {
  input?: InputMaybe<CustomerUpdateMyUserInput>
}

export type MutationCustomerUpdateNotificationsEnabledArgs = {
  notificationsEnabled: Scalars['Boolean']['input']
}

export type MutationCustomerUpdateUserArgs = {
  input?: InputMaybe<CustomerUpdateUserInput>
}

export type MutationOAuth2ExchangeArgs = {
  code: Scalars['String']['input']
  state: Scalars['String']['input']
}

export type MutationOAuth2RefreshArgs = {
  refreshToken: Scalars['String']['input']
}

export type NotificationsEnabled = {
  __typename: 'NotificationsEnabled'
  id: Scalars['ID']['output']
  notificationsEnabled: Scalars['Boolean']['output']
}

export type Offer = {
  __typename: 'Offer'
  accepted: Scalars['Boolean']['output']
  acceptedAmount?: Maybe<Scalars['Float']['output']>
  acceptedRate?: Maybe<Scalars['Float']['output']>
  acceptedTerm?: Maybe<Scalars['Int']['output']>
  createdAt: Scalars['String']['output']
  id: Scalars['ID']['output']
  lending?: Maybe<Lending>
  maxAmount: Scalars['Float']['output']
  maxRate: Scalars['Float']['output']
  maxTerm: Scalars['Int']['output']
  minAmount: Scalars['Float']['output']
  minRate: Scalars['Float']['output']
  minTerm: Scalars['Int']['output']
  status: OfferStatus
}

export enum OfferStatus {
  Completed = 'COMPLETED',
  Expired = 'EXPIRED',
  Pending = 'PENDING',
  Review = 'REVIEW'
}

/** Possible directions in which to order a list of items when provided an `orderBy` argument. */
export enum OrderDirection {
  /** Specifies an ascending order for a given `orderBy` argument. */
  Asc = 'ASC',
  /** Specifies a descending order for a given `orderBy` argument. */
  Desc = 'DESC'
}

/**
 * Information about pagination in a connection.
 * https://relay.dev/graphql/connections.htm#sec-undefined.PageInfo
 */
export type PageInfo = {
  __typename: 'PageInfo'
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['Cursor']['output']>
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output']
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output']
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['Cursor']['output']>
}

export type Partner = AddressInterface & {
  __typename: 'Partner'
  city?: Maybe<Scalars['String']['output']>
  companyType?: Maybe<Scalars['String']['output']>
  country?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['String']['output']
  description?: Maybe<Scalars['String']['output']>
  ein?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  industry?: Maybe<Scalars['String']['output']>
  isOnboarded: Scalars['Boolean']['output']
  legalName?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  paymentsPortalCustomInvoices?: Maybe<Scalars['Boolean']['output']>
  paymentsPortalCustomUrl?: Maybe<Scalars['String']['output']>
  paymentsPortalCustomization: PartnerPaymentsPortalCustomization
  paymentsPortalDefaultUrl?: Maybe<Scalars['String']['output']>
  paymentsPortalEnabled: Scalars['Boolean']['output']
  paymentsPortalMethods: Array<PartnerPaymentsPortalMethod>
  paymentsPortalUrl?: Maybe<Scalars['String']['output']>
  paymentsPortalUseCustomUrl?: Maybe<Scalars['Boolean']['output']>
  postalCode?: Maybe<Scalars['String']['output']>
  requiresMFA: Scalars['Boolean']['output']
  state?: Maybe<Scalars['String']['output']>
  streetAddress?: Maybe<Scalars['String']['output']>
  subPremise?: Maybe<Scalars['String']['output']>
}

export type PartnerAutopayConfig = {
  __typename: 'PartnerAutopayConfig'
  allowCustomerEdit?: Maybe<Scalars['Boolean']['output']>
  id: Scalars['ID']['output']
  partner: Partner
}

export type PartnerPaymentsPortalCustomization = {
  __typename: 'PartnerPaymentsPortalCustomization'
  color?: Maybe<Scalars['String']['output']>
  logoUrl?: Maybe<Scalars['String']['output']>
}

export enum PartnerPaymentsPortalMethod {
  Ach = 'ACH',
  Bnpl = 'BNPL',
  Card = 'CARD'
}

export type PartnerSubscription = {
  __typename: 'PartnerSubscription'
  amount: Scalars['Float']['output']
  createdDate: Scalars['String']['output']
  firstBillingDate: Scalars['String']['output']
  frequency: SubscriptionFrequency
  id: Scalars['ID']['output']
  lastStatus: SubscriptionStatus
  nextBillingDate: Scalars['String']['output']
  partner: Partner
  type: SubscriptionType
}

export type Payment = {
  __typename: 'Payment'
  amount: Scalars['Float']['output']
  creationDate: Scalars['String']['output']
  currentPaymentMethod?: Maybe<TransferPaymentMethodEnum>
  customer: Customer
  dueDate?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  netAmount: Scalars['Float']['output']
  partner: Partner
  payerCompanyType: CompanyType
  paymentCompletionForecastDate?: Maybe<Scalars['String']['output']>
  paymentFees: Array<Maybe<PaymentFee>>
  product: Product
  statuses: Array<Maybe<PaymentStatus>>
  transaction?: Maybe<Transaction>
}

export type PaymentCompanyConfig = {
  __typename: 'PaymentCompanyConfig'
  company: CompanyUnion
  id?: Maybe<Scalars['ID']['output']>
  paymentMethod?: Maybe<TransferPaymentMethodEnum>
  paymentMethodEntity?: Maybe<PaymentMethodEntity>
}

export type PaymentCompanyConfigUpdateInput = {
  paymentMethod?: InputMaybe<TransferPaymentMethodEnum>
  paymentMethodID: Scalars['ID']['input']
}

/** A connection to a list of items. */
export type PaymentConnection = {
  __typename: 'PaymentConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PaymentEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type PaymentEdge = {
  __typename: 'PaymentEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output']
  /** The item at the end of the edge. */
  node?: Maybe<Payment>
}

export type PaymentFee = {
  __typename: 'PaymentFee'
  amount: Scalars['Float']['output']
  forwarded: Scalars['Boolean']['output']
  name: Scalars['String']['output']
  type: FeeType
}

export type PaymentFilter = {
  amountEnd?: InputMaybe<Scalars['Float']['input']>
  amountStart?: InputMaybe<Scalars['Float']['input']>
  creationDateEnd?: InputMaybe<Scalars['String']['input']>
  creationDateStart?: InputMaybe<Scalars['String']['input']>
  dueDateEnd?: InputMaybe<Scalars['String']['input']>
  dueDateStart?: InputMaybe<Scalars['String']['input']>
  excludeBNPL?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  payerEntity?: InputMaybe<CompanyType>
  paymentCompletionForecastDateFrom?: InputMaybe<Scalars['String']['input']>
  paymentCompletionForecastDateTo?: InputMaybe<Scalars['String']['input']>
  paymentMethod?: InputMaybe<TransferPaymentMethodEnum>
  productId?: InputMaybe<Scalars['ID']['input']>
  productType?: InputMaybe<ProductType>
  productTypeIn?: InputMaybe<Array<InputMaybe<ProductType>>>
  status?: InputMaybe<Array<InputMaybe<PaymentStatusEnum>>>
}

export type PaymentMethodEntity = Account | Card

export type PaymentOrder = {
  direction?: OrderDirection
  field?: PaymentOrderField
}

export enum PaymentOrderField {
  CreatedAt = 'CREATED_AT'
}

export type PaymentStatus = {
  __typename: 'PaymentStatus'
  createdAt: Scalars['String']['output']
  status?: Maybe<PaymentStatusEnum>
}

export enum PaymentStatusEnum {
  Canceled = 'CANCELED',
  Chargeback = 'CHARGEBACK',
  Creating = 'CREATING',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Refunded = 'REFUNDED',
  Scheduled = 'SCHEDULED',
  Succeeded = 'SUCCEEDED'
}

export type PlaidInstitutionConnectionStatus = {
  __typename: 'PlaidInstitutionConnectionStatus'
  connectionId: Scalars['ID']['output']
  needsUpdate: Scalars['Boolean']['output']
}

export type Product = InstantPayment | Invoice | Offer | SubscriptionPayment

export enum ProductType {
  InstantPayment = 'INSTANT_PAYMENT',
  Invoice = 'INVOICE',
  Offer = 'OFFER',
  Subscription = 'SUBSCRIPTION'
}

export type Query = {
  __typename: 'Query'
  CustomerAutopayRuleConnection?: Maybe<AutopayRuleConnection>
  CustomerGetCardFee?: Maybe<CardFeeAmount>
  CustomerGetCardFees?: Maybe<Array<CustomerCardFeeDetail>>
  CustomerGetCardPubKey?: Maybe<Scalars['String']['output']>
  CustomerGetForwardingConfig?: Maybe<CustomerForwardingConfig>
  CustomerGetInstitutionUpdateLinkToken?: Maybe<Scalars['String']['output']>
  CustomerGetInvoicePdfLink: InvoicePdfLink
  CustomerGetLinkToken?: Maybe<Scalars['String']['output']>
  CustomerGetNotificationsEnabled: NotificationsEnabled
  CustomerGetPartnerAutopayConfig?: Maybe<PartnerAutopayConfig>
  CustomerGetPaymentConfig?: Maybe<PaymentCompanyConfig>
  CustomerInvoiceBnplConnection?: Maybe<InvoiceBnplConnection>
  CustomerInvoiceBnplTotals?: Maybe<InvoiceBnplTotals>
  CustomerInvoiceConnection: InvoiceConnection
  CustomerInvoiceTotals?: Maybe<InvoiceTotals>
  CustomerListBankingIntegrations: Array<Maybe<Institution>>
  CustomerListCards?: Maybe<Array<Maybe<Card>>>
  CustomerPaymentConnection?: Maybe<PaymentConnection>
  CustomerUserConnection?: Maybe<CustomerUserConnection>
  FindInvoice?: Maybe<Invoice>
  FindPartnerByPaymentsPortalUrl?: Maybe<Partner>
  GetCustomerUserTeams: GetCustomerUserTeamsReply
  GetCustomerUsers: Array<Maybe<CustomerUserInfo>>
  GetInvoiceDownloadLink: DownloadableInvoiceLink
  GetPartnerById?: Maybe<Partner>
  GetPartnerIdByLoginChallenge: Scalars['String']['output']
  GetSupportPreferences?: Maybe<SupportPreferences>
  GetUserCustomers: Array<Maybe<Customer>>
  GetUserEmailByKratosIdentity: Scalars['String']['output']
  GetUserInfo?: Maybe<CustomerGetUserInfoReply>
  GetUserKratosCredentials: UserKratosCredentials
  OAuth2Url: Scalars['String']['output']
  UserHasKratosIdentity: Scalars['Boolean']['output']
}

export type QueryCustomerAutopayRuleConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<AutopayRuleOrderBy>
}

export type QueryCustomerGetCardFeeArgs = {
  input: GetCardFeeInput
}

export type QueryCustomerGetCardPubKeyArgs = {
  input: GetCardPubKey
}

export type QueryCustomerGetInstitutionUpdateLinkTokenArgs = {
  connectionID: Scalars['String']['input']
  redirectURI: Scalars['String']['input']
}

export type QueryCustomerGetInvoicePdfLinkArgs = {
  invoiceID: Scalars['String']['input']
}

export type QueryCustomerGetLinkTokenArgs = {
  redirectURI: Scalars['String']['input']
}

export type QueryCustomerInvoiceBnplConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filters?: InputMaybe<BnplFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
}

export type QueryCustomerInvoiceBnplTotalsArgs = {
  filters?: InputMaybe<BnplFilter>
}

export type QueryCustomerInvoiceConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filters?: InputMaybe<InvoiceFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<InvoiceOrderBy>
}

export type QueryCustomerInvoiceTotalsArgs = {
  filters?: InputMaybe<InvoiceFilter>
}

export type QueryCustomerListCardsArgs = {
  filter?: InputMaybe<ListCardsFilterInput>
}

export type QueryCustomerPaymentConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<PaymentOrder>
  paymentFilter?: InputMaybe<PaymentFilter>
}

export type QueryCustomerUserConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<CustomerUserOrderBy>
}

export type QueryFindInvoiceArgs = {
  id: Scalars['String']['input']
}

export type QueryFindPartnerByPaymentsPortalUrlArgs = {
  url: Scalars['String']['input']
}

export type QueryGetInvoiceDownloadLinkArgs = {
  invoiceId: Scalars['String']['input']
}

export type QueryGetPartnerByIdArgs = {
  partnerId: Scalars['String']['input']
}

export type QueryGetPartnerIdByLoginChallengeArgs = {
  loginChallenge: Scalars['String']['input']
}

export type QueryGetUserKratosCredentialsArgs = {
  identifier: Scalars['String']['input']
}

export type QueryUserHasKratosIdentityArgs = {
  identifier: Scalars['String']['input']
}

export type QuickbooksRecurringTransaction = {
  __typename: 'QuickbooksRecurringTransaction'
  externalID: Scalars['String']['output']
  name: Scalars['String']['output']
  partnerID: Scalars['String']['output']
}

export enum RuleOperator {
  Equal = 'EQUAL',
  GreaterThan = 'GREATER_THAN',
  LessThan = 'LESS_THAN'
}

export enum SubscriptionFrequency {
  Annual = 'ANNUAL',
  Monthly = 'MONTHLY'
}

export type SubscriptionPayment = {
  __typename: 'SubscriptionPayment'
  amount: Scalars['Float']['output']
  id: Scalars['ID']['output']
  paymentDate: Scalars['String']['output']
  status: SubscriptionPaymentStatus
  subscription: PartnerSubscription
}

export enum SubscriptionPaymentStatus {
  Overdue = 'OVERDUE',
  Paid = 'PAID',
  Processing = 'PROCESSING'
}

export enum SubscriptionStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export enum SubscriptionType {
  Insights = 'INSIGHTS',
  Platform = 'PLATFORM'
}

export type SuperAdminUser = {
  __typename: 'SuperAdminUser'
  createdAt: Scalars['String']['output']
  email: Scalars['String']['output']
  firstName?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  lastName?: Maybe<Scalars['String']['output']>
  role: SuperAdminUserRole
}

export enum SuperAdminUserRole {
  Admin = 'ADMIN',
  Member = 'MEMBER'
}

export type SupportPreferences = {
  __typename: 'SupportPreferences'
  email: Scalars['String']['output']
  firstLine: Scalars['String']['output']
  name: Scalars['String']['output']
  partnerID: Scalars['ID']['output']
  phone?: Maybe<Scalars['String']['output']>
  secondLine?: Maybe<Scalars['String']['output']>
}

export type TokenExchange = {
  __typename: 'TokenExchange'
  access_token: Scalars['String']['output']
  expiry: Scalars['String']['output']
  id_token: Scalars['String']['output']
  refresh_token: Scalars['String']['output']
}

export type Transaction = {
  __typename: 'Transaction'
  amount: Scalars['Float']['output']
  companyType: CompanyType
  customer: Customer
  description: Scalars['String']['output']
  direction: TransactionDirection
  failureReason?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  netAmount: Scalars['Float']['output']
  partner: Partner
  status: TransactionStatus
  transactionMethod: TransactionMethod
}

export enum TransactionDirection {
  Credit = 'CREDIT',
  Debit = 'DEBIT'
}

export enum TransactionMethod {
  Ach = 'ACH',
  Card = 'CARD',
  Manual = 'MANUAL',
  Rtp = 'RTP',
  SameDayAch = 'SAME_DAY_ACH',
  Wire = 'WIRE'
}

export enum TransactionStatus {
  Canceled = 'CANCELED',
  Chargeback = 'CHARGEBACK',
  Charged = 'CHARGED',
  Created = 'CREATED',
  Failed = 'FAILED',
  Processing = 'PROCESSING',
  Refunded = 'REFUNDED',
  Succeeded = 'SUCCEEDED'
}

export enum TransferPaymentMethodEnum {
  Card = 'CARD',
  StandardAch = 'STANDARD_ACH'
}

export type UserKratosCredentials = {
  __typename: 'UserKratosCredentials'
  credentials: Array<Scalars['String']['output']>
}

export enum UserType {
  Customer = 'CUSTOMER',
  Partner = 'PARTNER',
  Superadmin = 'SUPERADMIN'
}

export type OAuth2UrlQueryVariables = Exact<{ [key: string]: never }>

export type OAuth2UrlQuery = { __typename: 'Query'; OAuth2Url: string }

export type OAuth2ExchangeMutationVariables = Exact<{
  code: Scalars['String']['input']
  state: Scalars['String']['input']
}>

export type OAuth2ExchangeMutation = {
  __typename: 'Mutation'
  OAuth2Exchange: {
    __typename: 'TokenExchange'
    access_token: string
    refresh_token: string
    expiry: string
    id_token: string
  }
}

export type OAuth2RefreshMutationVariables = Exact<{
  refreshToken: Scalars['String']['input']
}>

export type OAuth2RefreshMutation = {
  __typename: 'Mutation'
  OAuth2Refresh: {
    __typename: 'TokenExchange'
    access_token: string
    refresh_token: string
    expiry: string
    id_token: string
  }
}

export type TokenFragment = {
  __typename: 'TokenExchange'
  access_token: string
  refresh_token: string
  expiry: string
  id_token: string
}

export type CustomerAutopayRuleConnectionQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<AutopayRuleOrderBy>
}>

export type CustomerAutopayRuleConnectionQuery = {
  __typename: 'Query'
  CustomerAutopayRuleConnection?: {
    __typename: 'AutopayRuleConnection'
    edges?: Array<{
      __typename: 'AutopayRuleEdge'
      cursor: any
      node?: {
        __typename: 'AutopayRule'
        id: string
        daysPastCreation?: number | null
        daysPastDue?: number | null
        daysBeforeDue?: number | null
        amountOperator?: RuleOperator | null
        amount?: number | null
        halopsaRecurringInvoices?: boolean | null
        createdByCustomer: boolean
        autotaskContractTypes?: Array<{
          __typename: 'AutotaskContractType'
          externalID: string
          partnerID: string
          name: string
        }> | null
        connectwiseAgreementTypes?: Array<{
          __typename: 'ConnectwiseAgreementType'
          externalID: string
          partnerID: string
          name: string
        }> | null
        haloPSAContractSubtypes?: Array<{
          __typename: 'HaloPSAContractSubtype'
          externalID: string
          partnerID: string
          name: string
        }> | null
        quickbooksRecurringTransactions?: Array<{
          __typename: 'QuickbooksRecurringTransaction'
          externalID: string
          partnerID: string
          name: string
        }> | null
        customers?: Array<{
          __typename: 'Customer'
          id: string
          name?: string | null
        } | null> | null
      } | null
    } | null> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasPreviousPage: boolean
      endCursor?: any | null
    }
  } | null
}

export type CustomerCreateAutopayRuleMutationVariables = Exact<{
  input: CustomerCreateAutopayRuleInput
}>

export type CustomerCreateAutopayRuleMutation = {
  __typename: 'Mutation'
  CustomerCreateAutopayRule?: {
    __typename: 'AutopayRule'
    id: string
    daysPastCreation?: number | null
    daysPastDue?: number | null
    daysBeforeDue?: number | null
    amountOperator?: RuleOperator | null
    amount?: number | null
    halopsaRecurringInvoices?: boolean | null
    createdByCustomer: boolean
    autotaskContractTypes?: Array<{
      __typename: 'AutotaskContractType'
      externalID: string
      partnerID: string
      name: string
    }> | null
    connectwiseAgreementTypes?: Array<{
      __typename: 'ConnectwiseAgreementType'
      externalID: string
      partnerID: string
      name: string
    }> | null
    haloPSAContractSubtypes?: Array<{
      __typename: 'HaloPSAContractSubtype'
      externalID: string
      partnerID: string
      name: string
    }> | null
    quickbooksRecurringTransactions?: Array<{
      __typename: 'QuickbooksRecurringTransaction'
      externalID: string
      partnerID: string
      name: string
    }> | null
    customers?: Array<{
      __typename: 'Customer'
      id: string
      name?: string | null
    } | null> | null
  } | null
}

export type CustomerAutopayExcludedCustomerCreateMutationVariables = Exact<{
  [key: string]: never
}>

export type CustomerAutopayExcludedCustomerCreateMutation = {
  __typename: 'Mutation'
  CustomerAutopayExcludedCustomerCreate?: {
    __typename: 'AutopayExcludedCustomer'
    id: string
    customer: { __typename: 'Customer'; id: string; name?: string | null }
  } | null
}

export type CustomerAutopayRulesFragment = {
  __typename: 'AutopayRule'
  id: string
  daysPastCreation?: number | null
  daysPastDue?: number | null
  daysBeforeDue?: number | null
  amountOperator?: RuleOperator | null
  amount?: number | null
  halopsaRecurringInvoices?: boolean | null
  createdByCustomer: boolean
  autotaskContractTypes?: Array<{
    __typename: 'AutotaskContractType'
    externalID: string
    partnerID: string
    name: string
  }> | null
  connectwiseAgreementTypes?: Array<{
    __typename: 'ConnectwiseAgreementType'
    externalID: string
    partnerID: string
    name: string
  }> | null
  haloPSAContractSubtypes?: Array<{
    __typename: 'HaloPSAContractSubtype'
    externalID: string
    partnerID: string
    name: string
  }> | null
  quickbooksRecurringTransactions?: Array<{
    __typename: 'QuickbooksRecurringTransaction'
    externalID: string
    partnerID: string
    name: string
  }> | null
  customers?: Array<{
    __typename: 'Customer'
    id: string
    name?: string | null
  } | null> | null
}

export type CustomerInvoiceBnplTotalsQueryVariables = Exact<{
  filters?: InputMaybe<BnplFilter>
}>

export type CustomerInvoiceBnplTotalsQuery = {
  __typename: 'Query'
  CustomerInvoiceBnplTotals?: {
    __typename: 'InvoiceBnplTotals'
    count: number
    offerAmount: number
    invoiceAmount: number
  } | null
}

export type CustomerInvoiceBnplConnectionQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  filters?: InputMaybe<BnplFilter>
}>

export type CustomerInvoiceBnplConnectionQuery = {
  __typename: 'Query'
  CustomerInvoiceBnplConnection?: {
    __typename: 'InvoiceBnplConnection'
    edges?: Array<{
      __typename: 'InvoiceBnplEdge'
      node?: {
        __typename: 'Invoice'
        amount: number
        createdAt: string
        dueDate?: string | null
        id: string
        invoiceNumber: string
        outstandingAmount: number
        productName?: string | null
        status: InvoiceStatus
        recurringpayment: boolean
        partner?: {
          __typename: 'Partner'
          legalName?: string | null
          paymentsPortalEnabled: boolean
          paymentsPortalMethods: Array<PartnerPaymentsPortalMethod>
          paymentsPortalUrl?: string | null
          paymentsPortalCustomUrl?: string | null
          paymentsPortalUseCustomUrl?: boolean | null
          paymentsPortalDefaultUrl?: string | null
          paymentsPortalCustomInvoices?: boolean | null
          streetAddress?: string | null
          subPremise?: string | null
          city?: string | null
          state?: string | null
          postalCode?: string | null
          country?: string | null
          id: string
          name?: string | null
          paymentsPortalCustomization: {
            __typename: 'PartnerPaymentsPortalCustomization'
            color?: string | null
            logoUrl?: string | null
          }
        } | null
        offer?: {
          __typename: 'BNPLOffer'
          id: string
          amount: number
          createdAt: string
          remainingBalance: number
          netAmount: number
          terms: number
          status: BnplStatus
        } | null
        lending?: {
          __typename: 'Lending'
          installments?: Array<{
            __typename: 'Installment'
            id: string
            amount: number
            netAmount: number
            dueDate: string
            status: InstallmentStatus
            payments: Array<{
              __typename: 'Payment'
              amount: number
              netAmount: number
              creationDate: string
              currentPaymentMethod?: TransferPaymentMethodEnum | null
              transaction?: {
                __typename: 'Transaction'
                transactionMethod: TransactionMethod
              } | null
              statuses: Array<{
                __typename: 'PaymentStatus'
                status?: PaymentStatusEnum | null
                createdAt: string
              } | null>
            } | null>
          } | null> | null
        } | null
        directPayment?: {
          __typename: 'DirectPayment'
          id: string
          status: DirectPaymentStatus
          payments: Array<{
            __typename: 'Payment'
            transaction?: {
              __typename: 'Transaction'
              failureReason?: string | null
            } | null
          } | null>
        } | null
      } | null
    } | null> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasNextPage: boolean
      endCursor?: any | null
    }
  } | null
}

export type CustomerBnplOfferCreateMutationVariables = Exact<{
  input?: InputMaybe<BnplCreateInput>
}>

export type CustomerBnplOfferCreateMutation = {
  __typename: 'Mutation'
  CustomerBNPLOfferCreate?: string | null
}

export type GetRateMutationVariables = Exact<{
  input?: InputMaybe<BnplGetRateInput>
}>

export type GetRateMutation = {
  __typename: 'Mutation'
  CustomerBNPLOfferGetRate?: {
    __typename: 'BNPLRateResult'
    amount: number
    fees: number
    netAmount: number
    rate: number
    term: number
    installment: number
  } | null
}

export type BnplRateFragment = {
  __typename: 'BNPLRateResult'
  amount: number
  fees: number
  netAmount: number
  rate: number
  term: number
  installment: number
}

export type CustomerListBankingIntegrationsQueryVariables = Exact<{
  [key: string]: never
}>

export type CustomerListBankingIntegrationsQuery = {
  __typename: 'Query'
  CustomerListBankingIntegrations: Array<{
    __typename: 'Institution'
    id: string
    externalId?: string | null
    name?: string | null
    url?: string | null
    logo?: string | null
    accounts?: Array<{
      __typename: 'Account'
      id: string
      mask?: string | null
      name?: string | null
      type?: string | null
      subtype?: string | null
      hasAchAccountNumber?: boolean | null
      hasAchRoutingNumber?: boolean | null
      hasWireRoutingNumber?: boolean | null
      provider?: string | null
      disconnectedAt?: string | null
      systemDeactivatedAt?: string | null
      institution?: {
        __typename: 'Institution'
        id: string
        externalId?: string | null
        name?: string | null
        logo?: string | null
      } | null
    } | null> | null
  } | null>
}

export type CustomerGetLinkTokenQueryVariables = Exact<{
  redirectURI: Scalars['String']['input']
}>

export type CustomerGetLinkTokenQuery = {
  __typename: 'Query'
  CustomerGetLinkToken?: string | null
}

export type CustomerArchiveAccountMutationVariables = Exact<{
  accountID: Scalars['ID']['input']
}>

export type CustomerArchiveAccountMutation = {
  __typename: 'Mutation'
  CustomerArchiveAccount: string
}

export type CustomerAddManualBankingConnectionMutationVariables = Exact<{
  accountInformation: ManualBankingAccountInformationInput
}>

export type CustomerAddManualBankingConnectionMutation = {
  __typename: 'Mutation'
  CustomerAddManualBankingConnection?: string | null
}

export type CustomerAddPlaidConnectionMutationVariables = Exact<{
  publicToken: Scalars['String']['input']
  institutionId?: InputMaybe<Scalars['String']['input']>
  accountIds: Array<Scalars['String']['input']> | Scalars['String']['input']
}>

export type CustomerAddPlaidConnectionMutation = {
  __typename: 'Mutation'
  CustomerAddPlaidBankingConnection?: string | null
}

export type CustomerBankFragment = {
  __typename: 'Institution'
  id: string
  externalId?: string | null
  name?: string | null
  url?: string | null
  logo?: string | null
  accounts?: Array<{
    __typename: 'Account'
    id: string
    mask?: string | null
    name?: string | null
    type?: string | null
    subtype?: string | null
    hasAchAccountNumber?: boolean | null
    hasAchRoutingNumber?: boolean | null
    hasWireRoutingNumber?: boolean | null
    provider?: string | null
    disconnectedAt?: string | null
    systemDeactivatedAt?: string | null
    institution?: {
      __typename: 'Institution'
      id: string
      externalId?: string | null
      name?: string | null
      logo?: string | null
    } | null
  } | null> | null
}

export type CustomerBankAccountFragment = {
  __typename: 'Account'
  id: string
  mask?: string | null
  name?: string | null
  type?: string | null
  subtype?: string | null
  hasAchAccountNumber?: boolean | null
  hasAchRoutingNumber?: boolean | null
  hasWireRoutingNumber?: boolean | null
  provider?: string | null
  disconnectedAt?: string | null
  systemDeactivatedAt?: string | null
  institution?: {
    __typename: 'Institution'
    id: string
    externalId?: string | null
    name?: string | null
    logo?: string | null
  } | null
}

export type CustomerListCardsQueryVariables = Exact<{
  filter?: InputMaybe<ListCardsFilterInput>
}>

export type CustomerListCardsQuery = {
  __typename: 'Query'
  CustomerListCards?: Array<{
    __typename: 'Card'
    id: string
    last4: string
    expirationDate: string
    cardNetWork: CardNetwork
  } | null> | null
}

export type CustomerGetCardPubKeyQueryVariables = Exact<{
  input: GetCardPubKey
}>

export type CustomerGetCardPubKeyQuery = {
  __typename: 'Query'
  CustomerGetCardPubKey?: string | null
}

export type CustomerGetCardFeeQueryVariables = Exact<{
  input: GetCardFeeInput
}>

export type CustomerGetCardFeeQuery = {
  __typename: 'Query'
  CustomerGetCardFee?: {
    __typename: 'CardFeeAmount'
    percentage: number
    feeAmount: number
  } | null
}

export type CustomerGetCardFeesQueryVariables = Exact<{ [key: string]: never }>

export type CustomerGetCardFeesQuery = {
  __typename: 'Query'
  CustomerGetCardFees?: Array<{
    __typename: 'CustomerCardFeeDetail'
    percentage: number
    cardNetwork: CardNetwork
  }> | null
}

export type CustomerCreateCardMutationVariables = Exact<{
  input: CardCreationInput
}>

export type CustomerCreateCardMutation = {
  __typename: 'Mutation'
  CustomerCreateCard?: string | null
}

export type CustomerDeleteCardMutationVariables = Exact<{
  input: CardDeletionInput
}>

export type CustomerDeleteCardMutation = {
  __typename: 'Mutation'
  CustomerDeleteCard?: string | null
}

export type CustomerModernBancGenerateSerializedTokenMutationVariables = Exact<{
  input: CardSerializationInput
}>

export type CustomerModernBancGenerateSerializedTokenMutation = {
  __typename: 'Mutation'
  CustomerModernBancGenerateSerializedToken?: string | null
}

export type CustomerCreditCardFragment = {
  __typename: 'Card'
  id: string
  last4: string
  expirationDate: string
  cardNetWork: CardNetwork
}

export type CustomerRequestAccessMutationVariables = Exact<{
  [key: string]: never
}>

export type CustomerRequestAccessMutation = {
  __typename: 'Mutation'
  CustomerRequestAccess: string
}

export type GetUserCustomersQueryVariables = Exact<{ [key: string]: never }>

export type GetUserCustomersQuery = {
  __typename: 'Query'
  GetUserCustomers: Array<{
    __typename: 'Customer'
    id: string
    name?: string | null
    legalName?: string | null
    streetAddress?: string | null
    subPremise?: string | null
    city?: string | null
    state?: string | null
    postalCode?: string | null
    country?: string | null
  } | null>
}

export type GetCustomerUserTeamsQueryVariables = Exact<{ [key: string]: never }>

export type GetCustomerUserTeamsQuery = {
  __typename: 'Query'
  GetCustomerUserTeams: {
    __typename: 'GetCustomerUserTeamsReply'
    portals?: Array<{
      __typename: 'GetCustomerUserPortals'
      partner: {
        __typename: 'Partner'
        id: string
        name?: string | null
        paymentsPortalUrl?: string | null
      }
      teams?: Array<{
        __typename: 'Customer'
        id: string
        name?: string | null
      }> | null
    }> | null
  }
}

export type CustomerUserConnectionQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<CustomerUserOrderBy>
}>

export type CustomerUserConnectionQuery = {
  __typename: 'Query'
  CustomerUserConnection?: {
    __typename: 'CustomerUserConnection'
    edges?: Array<{
      __typename: 'CustomerUserEdge'
      node?: {
        __typename: 'CustomerUser'
        role: CustomerUserRole
        createdAt: string
        id: string
        firstName?: string | null
        lastName?: string | null
        email: string
      } | null
    } | null> | null
  } | null
}

export type CustomerFinishOnboardingMutationVariables = Exact<{
  [key: string]: never
}>

export type CustomerFinishOnboardingMutation = {
  __typename: 'Mutation'
  CustomerFinishOnboarding?: {
    __typename: 'Customer'
    id: string
    isOnboarded: boolean
  } | null
}

export type CustomerDeleteUserMutationVariables = Exact<{
  id: Scalars['String']['input']
}>

export type CustomerDeleteUserMutation = {
  __typename: 'Mutation'
  CustomerDeleteUser?: string | null
}

export type CustomerUpdateUserMutationVariables = Exact<{
  input?: InputMaybe<CustomerUpdateUserInput>
}>

export type CustomerUpdateUserMutation = {
  __typename: 'Mutation'
  CustomerUpdateUser?: {
    __typename: 'CustomerUser'
    id: string
    firstName?: string | null
    lastName?: string | null
    email: string
  } | null
}

export type CustomerInviteUserMutationVariables = Exact<{
  input?: InputMaybe<CustomerInviteUserInput>
}>

export type CustomerInviteUserMutation = {
  __typename: 'Mutation'
  CustomerInviteUser?: {
    __typename: 'CustomerUser'
    id: string
    firstName?: string | null
    lastName?: string | null
    email: string
  } | null
}

export type CustomerUpdateAddressMutationVariables = Exact<{
  input?: InputMaybe<CustomerUpdateAddressInput>
}>

export type CustomerUpdateAddressMutation = {
  __typename: 'Mutation'
  CustomerUpdateAddress?: {
    __typename: 'Customer'
    id: string
    postalCode?: string | null
    country?: string | null
    streetAddress?: string | null
    subPremise?: string | null
    city?: string | null
    state?: string | null
  } | null
}

export type CustomerUpdateDetailsMutationVariables = Exact<{
  input?: InputMaybe<CustomerUpdateDetailsInput>
}>

export type CustomerUpdateDetailsMutation = {
  __typename: 'Mutation'
  CustomerUpdateDetails?: {
    __typename: 'Customer'
    id: string
    name?: string | null
    legalName?: string | null
    ein?: string | null
    companyType?: string | null
    industry?: string | null
    description?: string | null
  } | null
}

export type CustomerUpdateMyUserMutationVariables = Exact<{
  input?: InputMaybe<CustomerUpdateMyUserInput>
}>

export type CustomerUpdateMyUserMutation = {
  __typename: 'Mutation'
  CustomerUpdateMyUser?: {
    __typename: 'CustomerUser'
    id: string
    firstName?: string | null
    lastName?: string | null
    phone?: string | null
    jobTitle?: string | null
  } | null
}

export type CustomerUserBaseFragment = {
  __typename: 'CustomerUser'
  id: string
  firstName?: string | null
  lastName?: string | null
  email: string
}

export type CustomerListUserFragment = {
  __typename: 'CustomerUser'
  role: CustomerUserRole
  createdAt: string
  id: string
  firstName?: string | null
  lastName?: string | null
  email: string
}

export type CustomerBasicFragment = {
  __typename: 'Customer'
  id: string
  name?: string | null
  legalName?: string | null
  streetAddress?: string | null
  subPremise?: string | null
  city?: string | null
  state?: string | null
  postalCode?: string | null
  country?: string | null
}

export type FindInvoiceQueryVariables = Exact<{
  id: Scalars['String']['input']
}>

export type FindInvoiceQuery = {
  __typename: 'Query'
  FindInvoice?: {
    __typename: 'Invoice'
    amount: number
    createdAt: string
    dueDate?: string | null
    id: string
    invoiceNumber: string
    outstandingAmount: number
    productName?: string | null
    status: InvoiceStatus
    recurringpayment: boolean
    customer?: {
      __typename: 'Customer'
      id: string
      name?: string | null
      legalName?: string | null
      streetAddress?: string | null
      subPremise?: string | null
      city?: string | null
      state?: string | null
      postalCode?: string | null
      country?: string | null
    } | null
    partner?: {
      __typename: 'Partner'
      legalName?: string | null
      paymentsPortalEnabled: boolean
      paymentsPortalMethods: Array<PartnerPaymentsPortalMethod>
      paymentsPortalUrl?: string | null
      paymentsPortalCustomUrl?: string | null
      paymentsPortalUseCustomUrl?: boolean | null
      paymentsPortalDefaultUrl?: string | null
      paymentsPortalCustomInvoices?: boolean | null
      streetAddress?: string | null
      subPremise?: string | null
      city?: string | null
      state?: string | null
      postalCode?: string | null
      country?: string | null
      id: string
      name?: string | null
      paymentsPortalCustomization: {
        __typename: 'PartnerPaymentsPortalCustomization'
        color?: string | null
        logoUrl?: string | null
      }
    } | null
    offer?: {
      __typename: 'BNPLOffer'
      id: string
      amount: number
      createdAt: string
      remainingBalance: number
      netAmount: number
      terms: number
      status: BnplStatus
    } | null
    lending?: {
      __typename: 'Lending'
      installments?: Array<{
        __typename: 'Installment'
        id: string
        amount: number
        netAmount: number
        dueDate: string
        status: InstallmentStatus
        payments: Array<{
          __typename: 'Payment'
          amount: number
          netAmount: number
          creationDate: string
          currentPaymentMethod?: TransferPaymentMethodEnum | null
          transaction?: {
            __typename: 'Transaction'
            transactionMethod: TransactionMethod
          } | null
          statuses: Array<{
            __typename: 'PaymentStatus'
            status?: PaymentStatusEnum | null
            createdAt: string
          } | null>
        } | null>
      } | null> | null
    } | null
    directPayment?: {
      __typename: 'DirectPayment'
      id: string
      status: DirectPaymentStatus
      payments: Array<{
        __typename: 'Payment'
        transaction?: {
          __typename: 'Transaction'
          failureReason?: string | null
        } | null
      } | null>
    } | null
  } | null
}

export type CustomerInvoiceTotalsQueryVariables = Exact<{
  filters?: InputMaybe<InvoiceFilter>
}>

export type CustomerInvoiceTotalsQuery = {
  __typename: 'Query'
  CustomerInvoiceTotals?: {
    __typename: 'InvoiceTotals'
    count: number
    amount: number
  } | null
}

export type CustomerInvoiceConnectionQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  filters?: InputMaybe<InvoiceFilter>
  orderBy?: InputMaybe<InvoiceOrderBy>
}>

export type CustomerInvoiceConnectionQuery = {
  __typename: 'Query'
  CustomerInvoiceConnection: {
    __typename: 'InvoiceConnection'
    edges?: Array<{
      __typename: 'InvoiceEdge'
      node?: {
        __typename: 'Invoice'
        amount: number
        createdAt: string
        dueDate?: string | null
        id: string
        invoiceNumber: string
        outstandingAmount: number
        productName?: string | null
        status: InvoiceStatus
        recurringpayment: boolean
        partner?: {
          __typename: 'Partner'
          legalName?: string | null
          paymentsPortalEnabled: boolean
          paymentsPortalMethods: Array<PartnerPaymentsPortalMethod>
          paymentsPortalUrl?: string | null
          paymentsPortalCustomUrl?: string | null
          paymentsPortalUseCustomUrl?: boolean | null
          paymentsPortalDefaultUrl?: string | null
          paymentsPortalCustomInvoices?: boolean | null
          streetAddress?: string | null
          subPremise?: string | null
          city?: string | null
          state?: string | null
          postalCode?: string | null
          country?: string | null
          id: string
          name?: string | null
          paymentsPortalCustomization: {
            __typename: 'PartnerPaymentsPortalCustomization'
            color?: string | null
            logoUrl?: string | null
          }
        } | null
        offer?: {
          __typename: 'BNPLOffer'
          id: string
          amount: number
          createdAt: string
          remainingBalance: number
          netAmount: number
          terms: number
          status: BnplStatus
        } | null
        lending?: {
          __typename: 'Lending'
          installments?: Array<{
            __typename: 'Installment'
            id: string
            amount: number
            netAmount: number
            dueDate: string
            status: InstallmentStatus
            payments: Array<{
              __typename: 'Payment'
              amount: number
              netAmount: number
              creationDate: string
              currentPaymentMethod?: TransferPaymentMethodEnum | null
              transaction?: {
                __typename: 'Transaction'
                transactionMethod: TransactionMethod
              } | null
              statuses: Array<{
                __typename: 'PaymentStatus'
                status?: PaymentStatusEnum | null
                createdAt: string
              } | null>
            } | null>
          } | null> | null
        } | null
        directPayment?: {
          __typename: 'DirectPayment'
          id: string
          status: DirectPaymentStatus
          payments: Array<{
            __typename: 'Payment'
            transaction?: {
              __typename: 'Transaction'
              failureReason?: string | null
            } | null
          } | null>
        } | null
      } | null
    } | null> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasNextPage: boolean
      endCursor?: any | null
    }
  }
}

export type CustomerInvoiceCreateMutationVariables = Exact<{
  input?: InputMaybe<CustomerInvoiceCreateInput>
}>

export type CustomerInvoiceCreateMutation = {
  __typename: 'Mutation'
  CustomerInvoiceCreate?: {
    __typename: 'Invoice'
    amount: number
    createdAt: string
    dueDate?: string | null
    id: string
    invoiceNumber: string
    outstandingAmount: number
    productName?: string | null
    status: InvoiceStatus
    recurringpayment: boolean
    partner?: {
      __typename: 'Partner'
      legalName?: string | null
      paymentsPortalEnabled: boolean
      paymentsPortalMethods: Array<PartnerPaymentsPortalMethod>
      paymentsPortalUrl?: string | null
      paymentsPortalCustomUrl?: string | null
      paymentsPortalUseCustomUrl?: boolean | null
      paymentsPortalDefaultUrl?: string | null
      paymentsPortalCustomInvoices?: boolean | null
      streetAddress?: string | null
      subPremise?: string | null
      city?: string | null
      state?: string | null
      postalCode?: string | null
      country?: string | null
      id: string
      name?: string | null
      paymentsPortalCustomization: {
        __typename: 'PartnerPaymentsPortalCustomization'
        color?: string | null
        logoUrl?: string | null
      }
    } | null
    offer?: {
      __typename: 'BNPLOffer'
      id: string
      amount: number
      createdAt: string
      remainingBalance: number
      netAmount: number
      terms: number
      status: BnplStatus
    } | null
    lending?: {
      __typename: 'Lending'
      installments?: Array<{
        __typename: 'Installment'
        id: string
        amount: number
        netAmount: number
        dueDate: string
        status: InstallmentStatus
        payments: Array<{
          __typename: 'Payment'
          amount: number
          netAmount: number
          creationDate: string
          currentPaymentMethod?: TransferPaymentMethodEnum | null
          transaction?: {
            __typename: 'Transaction'
            transactionMethod: TransactionMethod
          } | null
          statuses: Array<{
            __typename: 'PaymentStatus'
            status?: PaymentStatusEnum | null
            createdAt: string
          } | null>
        } | null>
      } | null> | null
    } | null
    directPayment?: {
      __typename: 'DirectPayment'
      id: string
      status: DirectPaymentStatus
      payments: Array<{
        __typename: 'Payment'
        transaction?: {
          __typename: 'Transaction'
          failureReason?: string | null
        } | null
      } | null>
    } | null
  } | null
}

export type CustomerPayInvoiceMutationVariables = Exact<{
  invoiceID: Scalars['String']['input']
  paymentMethod?: InputMaybe<DirectPaymentPaymentMethodInput>
  paymentDate?: InputMaybe<Scalars['String']['input']>
}>

export type CustomerPayInvoiceMutation = {
  __typename: 'Mutation'
  CustomerPayInvoice?: {
    __typename: 'DirectPaymentCreationResponse'
    id?: string | null
    message?: string | null
  } | null
}

export type CustomerInvoiceFragment = {
  __typename: 'Invoice'
  amount: number
  createdAt: string
  dueDate?: string | null
  id: string
  invoiceNumber: string
  outstandingAmount: number
  productName?: string | null
  status: InvoiceStatus
  recurringpayment: boolean
  partner?: {
    __typename: 'Partner'
    legalName?: string | null
    paymentsPortalEnabled: boolean
    paymentsPortalMethods: Array<PartnerPaymentsPortalMethod>
    paymentsPortalUrl?: string | null
    paymentsPortalCustomUrl?: string | null
    paymentsPortalUseCustomUrl?: boolean | null
    paymentsPortalDefaultUrl?: string | null
    paymentsPortalCustomInvoices?: boolean | null
    streetAddress?: string | null
    subPremise?: string | null
    city?: string | null
    state?: string | null
    postalCode?: string | null
    country?: string | null
    id: string
    name?: string | null
    paymentsPortalCustomization: {
      __typename: 'PartnerPaymentsPortalCustomization'
      color?: string | null
      logoUrl?: string | null
    }
  } | null
  offer?: {
    __typename: 'BNPLOffer'
    id: string
    amount: number
    createdAt: string
    remainingBalance: number
    netAmount: number
    terms: number
    status: BnplStatus
  } | null
  lending?: {
    __typename: 'Lending'
    installments?: Array<{
      __typename: 'Installment'
      id: string
      amount: number
      netAmount: number
      dueDate: string
      status: InstallmentStatus
      payments: Array<{
        __typename: 'Payment'
        amount: number
        netAmount: number
        creationDate: string
        currentPaymentMethod?: TransferPaymentMethodEnum | null
        transaction?: {
          __typename: 'Transaction'
          transactionMethod: TransactionMethod
        } | null
        statuses: Array<{
          __typename: 'PaymentStatus'
          status?: PaymentStatusEnum | null
          createdAt: string
        } | null>
      } | null>
    } | null> | null
  } | null
  directPayment?: {
    __typename: 'DirectPayment'
    id: string
    status: DirectPaymentStatus
    payments: Array<{
      __typename: 'Payment'
      transaction?: {
        __typename: 'Transaction'
        failureReason?: string | null
      } | null
    } | null>
  } | null
}

export type CustomerFindInvoiceFragment = {
  __typename: 'Invoice'
  amount: number
  createdAt: string
  dueDate?: string | null
  id: string
  invoiceNumber: string
  outstandingAmount: number
  productName?: string | null
  status: InvoiceStatus
  recurringpayment: boolean
  customer?: {
    __typename: 'Customer'
    id: string
    name?: string | null
    legalName?: string | null
    streetAddress?: string | null
    subPremise?: string | null
    city?: string | null
    state?: string | null
    postalCode?: string | null
    country?: string | null
  } | null
  partner?: {
    __typename: 'Partner'
    legalName?: string | null
    paymentsPortalEnabled: boolean
    paymentsPortalMethods: Array<PartnerPaymentsPortalMethod>
    paymentsPortalUrl?: string | null
    paymentsPortalCustomUrl?: string | null
    paymentsPortalUseCustomUrl?: boolean | null
    paymentsPortalDefaultUrl?: string | null
    paymentsPortalCustomInvoices?: boolean | null
    streetAddress?: string | null
    subPremise?: string | null
    city?: string | null
    state?: string | null
    postalCode?: string | null
    country?: string | null
    id: string
    name?: string | null
    paymentsPortalCustomization: {
      __typename: 'PartnerPaymentsPortalCustomization'
      color?: string | null
      logoUrl?: string | null
    }
  } | null
  offer?: {
    __typename: 'BNPLOffer'
    id: string
    amount: number
    createdAt: string
    remainingBalance: number
    netAmount: number
    terms: number
    status: BnplStatus
  } | null
  lending?: {
    __typename: 'Lending'
    installments?: Array<{
      __typename: 'Installment'
      id: string
      amount: number
      netAmount: number
      dueDate: string
      status: InstallmentStatus
      payments: Array<{
        __typename: 'Payment'
        amount: number
        netAmount: number
        creationDate: string
        currentPaymentMethod?: TransferPaymentMethodEnum | null
        transaction?: {
          __typename: 'Transaction'
          transactionMethod: TransactionMethod
        } | null
        statuses: Array<{
          __typename: 'PaymentStatus'
          status?: PaymentStatusEnum | null
          createdAt: string
        } | null>
      } | null>
    } | null> | null
  } | null
  directPayment?: {
    __typename: 'DirectPayment'
    id: string
    status: DirectPaymentStatus
    payments: Array<{
      __typename: 'Payment'
      transaction?: {
        __typename: 'Transaction'
        failureReason?: string | null
      } | null
    } | null>
  } | null
}

export type CustomerInvoiceInstallmentFragment = {
  __typename: 'Installment'
  id: string
  amount: number
  netAmount: number
  dueDate: string
  status: InstallmentStatus
  payments: Array<{
    __typename: 'Payment'
    amount: number
    netAmount: number
    creationDate: string
    currentPaymentMethod?: TransferPaymentMethodEnum | null
    transaction?: {
      __typename: 'Transaction'
      transactionMethod: TransactionMethod
    } | null
    statuses: Array<{
      __typename: 'PaymentStatus'
      status?: PaymentStatusEnum | null
      createdAt: string
    } | null>
  } | null>
}

export type CustomerInstallmentPaymentFragment = {
  __typename: 'Payment'
  amount: number
  netAmount: number
  creationDate: string
  currentPaymentMethod?: TransferPaymentMethodEnum | null
  transaction?: {
    __typename: 'Transaction'
    transactionMethod: TransactionMethod
  } | null
  statuses: Array<{
    __typename: 'PaymentStatus'
    status?: PaymentStatusEnum | null
    createdAt: string
  } | null>
}

export type CustomerBnplOfferFragment = {
  __typename: 'BNPLOffer'
  id: string
  amount: number
  createdAt: string
  remainingBalance: number
  netAmount: number
  terms: number
  status: BnplStatus
}

export type CustomerGetInvoicePdfLinkQueryVariables = Exact<{
  invoiceID: Scalars['String']['input']
}>

export type CustomerGetInvoicePdfLinkQuery = {
  __typename: 'Query'
  CustomerGetInvoicePdfLink: {
    __typename: 'InvoicePdfLink'
    url: string
    expiresAt: string
  }
}

export type CustomerGetNotificationsEnabledQueryVariables = Exact<{
  [key: string]: never
}>

export type CustomerGetNotificationsEnabledQuery = {
  __typename: 'Query'
  CustomerGetNotificationsEnabled: {
    __typename: 'NotificationsEnabled'
    id: string
    notificationsEnabled: boolean
  }
}

export type CustomerUpdateNotificationsEnabledMutationVariables = Exact<{
  notificationsEnabled: Scalars['Boolean']['input']
}>

export type CustomerUpdateNotificationsEnabledMutation = {
  __typename: 'Mutation'
  CustomerUpdateNotificationsEnabled: {
    __typename: 'NotificationsEnabled'
    id: string
    notificationsEnabled: boolean
  }
}

export type GetSupportPreferencesQueryVariables = Exact<{
  [key: string]: never
}>

export type GetSupportPreferencesQuery = {
  __typename: 'Query'
  GetSupportPreferences?: {
    __typename: 'SupportPreferences'
    partnerID: string
    name: string
    email: string
    phone?: string | null
    firstLine: string
    secondLine?: string | null
  } | null
}

export type FindPartnerByPaymentsPortalUrlQueryVariables = Exact<{
  url: Scalars['String']['input']
}>

export type FindPartnerByPaymentsPortalUrlQuery = {
  __typename: 'Query'
  FindPartnerByPaymentsPortalUrl?: {
    __typename: 'Partner'
    legalName?: string | null
    paymentsPortalEnabled: boolean
    paymentsPortalMethods: Array<PartnerPaymentsPortalMethod>
    paymentsPortalUrl?: string | null
    paymentsPortalCustomUrl?: string | null
    paymentsPortalUseCustomUrl?: boolean | null
    paymentsPortalDefaultUrl?: string | null
    paymentsPortalCustomInvoices?: boolean | null
    streetAddress?: string | null
    subPremise?: string | null
    city?: string | null
    state?: string | null
    postalCode?: string | null
    country?: string | null
    id: string
    name?: string | null
    paymentsPortalCustomization: {
      __typename: 'PartnerPaymentsPortalCustomization'
      color?: string | null
      logoUrl?: string | null
    }
  } | null
}

export type GetPartnerIdByLoginChallengeQueryVariables = Exact<{
  loginChallenge: Scalars['String']['input']
}>

export type GetPartnerIdByLoginChallengeQuery = {
  __typename: 'Query'
  GetPartnerIdByLoginChallenge: string
}

export type GetPartnerByIdQueryVariables = Exact<{
  partnerId: Scalars['String']['input']
}>

export type GetPartnerByIdQuery = {
  __typename: 'Query'
  GetPartnerById?: {
    __typename: 'Partner'
    id: string
    name?: string | null
    legalName?: string | null
    paymentsPortalUrl?: string | null
    paymentsPortalCustomization: {
      __typename: 'PartnerPaymentsPortalCustomization'
      color?: string | null
      logoUrl?: string | null
    }
  } | null
}

export type PartnerWhitelabelFragment = {
  __typename: 'Partner'
  id: string
  name?: string | null
  legalName?: string | null
  paymentsPortalUrl?: string | null
  paymentsPortalCustomization: {
    __typename: 'PartnerPaymentsPortalCustomization'
    color?: string | null
    logoUrl?: string | null
  }
}

export type CustomerGetForwardingConfigQueryVariables = Exact<{
  [key: string]: never
}>

export type CustomerGetForwardingConfigQuery = {
  __typename: 'Query'
  CustomerGetForwardingConfig?: {
    __typename: 'CustomerForwardingConfig'
    coverDirectPaymentFees: boolean
    coverFeeConfig?: {
      __typename: 'CoverFeeConfig'
      coverCardMethodFee?: boolean | null
    } | null
    partner: { __typename: 'Partner'; id: string; name?: string | null }
    customer: { __typename: 'Customer'; id: string }
  } | null
}

export type CustomerPartnerBaseFragment = {
  __typename: 'Partner'
  id: string
  name?: string | null
}

export type CustomerPartnerFragment = {
  __typename: 'Partner'
  legalName?: string | null
  paymentsPortalEnabled: boolean
  paymentsPortalMethods: Array<PartnerPaymentsPortalMethod>
  paymentsPortalUrl?: string | null
  paymentsPortalCustomUrl?: string | null
  paymentsPortalUseCustomUrl?: boolean | null
  paymentsPortalDefaultUrl?: string | null
  paymentsPortalCustomInvoices?: boolean | null
  streetAddress?: string | null
  subPremise?: string | null
  city?: string | null
  state?: string | null
  postalCode?: string | null
  country?: string | null
  id: string
  name?: string | null
  paymentsPortalCustomization: {
    __typename: 'PartnerPaymentsPortalCustomization'
    color?: string | null
    logoUrl?: string | null
  }
}

export type SupportPreferencesFragment = {
  __typename: 'SupportPreferences'
  partnerID: string
  name: string
  email: string
  phone?: string | null
  firstLine: string
  secondLine?: string | null
}

export type CustomerGetPartnerAutopayConfigQueryVariables = Exact<{
  [key: string]: never
}>

export type CustomerGetPartnerAutopayConfigQuery = {
  __typename: 'Query'
  CustomerGetPartnerAutopayConfig?: {
    __typename: 'PartnerAutopayConfig'
    id: string
    allowCustomerEdit?: boolean | null
  } | null
}

export type CustomerGetPaymentConfigQueryVariables = Exact<{
  [key: string]: never
}>

export type CustomerGetPaymentConfigQuery = {
  __typename: 'Query'
  CustomerGetPaymentConfig?: {
    __typename: 'PaymentCompanyConfig'
    id?: string | null
    paymentMethod?: TransferPaymentMethodEnum | null
    paymentMethodEntity?:
      | {
          __typename: 'Account'
          id: string
          mask?: string | null
          name?: string | null
          institution?: {
            __typename: 'Institution'
            id: string
            logo?: string | null
          } | null
        }
      | {
          __typename: 'Card'
          id: string
          last4: string
          expirationDate: string
          cardNetWork: CardNetwork
        }
      | null
  } | null
}

export type CustomerChangePaymentConfigMutationVariables = Exact<{
  paymentConfig: PaymentCompanyConfigUpdateInput
}>

export type CustomerChangePaymentConfigMutation = {
  __typename: 'Mutation'
  CustomerChangePaymentConfig?: string | null
}

export type CustomerPaymentConfigFragment = {
  __typename: 'PaymentCompanyConfig'
  id?: string | null
  paymentMethod?: TransferPaymentMethodEnum | null
  paymentMethodEntity?:
    | {
        __typename: 'Account'
        id: string
        mask?: string | null
        name?: string | null
        institution?: {
          __typename: 'Institution'
          id: string
          logo?: string | null
        } | null
      }
    | {
        __typename: 'Card'
        id: string
        last4: string
        expirationDate: string
        cardNetWork: CardNetwork
      }
    | null
}

export type CustomerPaymentConnectionQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  paymentFilter?: InputMaybe<PaymentFilter>
  orderBy?: InputMaybe<PaymentOrder>
}>

export type CustomerPaymentConnectionQuery = {
  __typename: 'Query'
  CustomerPaymentConnection?: {
    __typename: 'PaymentConnection'
    edges?: Array<{
      __typename: 'PaymentEdge'
      cursor: any
      node?: {
        __typename: 'Payment'
        id: string
        dueDate?: string | null
        creationDate: string
        netAmount: number
        amount: number
        currentPaymentMethod?: TransferPaymentMethodEnum | null
        statuses: Array<{
          __typename: 'PaymentStatus'
          status?: PaymentStatusEnum | null
          createdAt: string
        } | null>
        partner: {
          __typename: 'Partner'
          name?: string | null
          legalName?: string | null
          subPremise?: string | null
          city?: string | null
          state?: string | null
          postalCode?: string | null
          country?: string | null
          streetAddress?: string | null
          paymentsPortalCustomization: {
            __typename: 'PartnerPaymentsPortalCustomization'
            color?: string | null
            logoUrl?: string | null
          }
        }
        transaction?: {
          __typename: 'Transaction'
          failureReason?: string | null
        } | null
        product:
          | { __typename: 'InstantPayment' }
          | {
              __typename: 'Invoice'
              amount: number
              createdAt: string
              dueDate?: string | null
              id: string
              invoiceNumber: string
              outstandingAmount: number
              productName?: string | null
              status: InvoiceStatus
              recurringpayment: boolean
              partner?: {
                __typename: 'Partner'
                legalName?: string | null
                paymentsPortalEnabled: boolean
                paymentsPortalMethods: Array<PartnerPaymentsPortalMethod>
                paymentsPortalUrl?: string | null
                paymentsPortalCustomUrl?: string | null
                paymentsPortalUseCustomUrl?: boolean | null
                paymentsPortalDefaultUrl?: string | null
                paymentsPortalCustomInvoices?: boolean | null
                streetAddress?: string | null
                subPremise?: string | null
                city?: string | null
                state?: string | null
                postalCode?: string | null
                country?: string | null
                id: string
                name?: string | null
                paymentsPortalCustomization: {
                  __typename: 'PartnerPaymentsPortalCustomization'
                  color?: string | null
                  logoUrl?: string | null
                }
              } | null
              offer?: {
                __typename: 'BNPLOffer'
                id: string
                amount: number
                createdAt: string
                remainingBalance: number
                netAmount: number
                terms: number
                status: BnplStatus
              } | null
              lending?: {
                __typename: 'Lending'
                installments?: Array<{
                  __typename: 'Installment'
                  id: string
                  amount: number
                  netAmount: number
                  dueDate: string
                  status: InstallmentStatus
                  payments: Array<{
                    __typename: 'Payment'
                    amount: number
                    netAmount: number
                    creationDate: string
                    currentPaymentMethod?: TransferPaymentMethodEnum | null
                    transaction?: {
                      __typename: 'Transaction'
                      transactionMethod: TransactionMethod
                    } | null
                    statuses: Array<{
                      __typename: 'PaymentStatus'
                      status?: PaymentStatusEnum | null
                      createdAt: string
                    } | null>
                  } | null>
                } | null> | null
              } | null
              directPayment?: {
                __typename: 'DirectPayment'
                id: string
                status: DirectPaymentStatus
                payments: Array<{
                  __typename: 'Payment'
                  transaction?: {
                    __typename: 'Transaction'
                    failureReason?: string | null
                  } | null
                } | null>
              } | null
            }
          | { __typename: 'Offer' }
          | { __typename: 'SubscriptionPayment' }
      } | null
    } | null> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasNextPage: boolean
      endCursor?: any | null
    }
  } | null
}

export type CustomerPaymentFragment = {
  __typename: 'Payment'
  id: string
  dueDate?: string | null
  creationDate: string
  netAmount: number
  amount: number
  currentPaymentMethod?: TransferPaymentMethodEnum | null
  statuses: Array<{
    __typename: 'PaymentStatus'
    status?: PaymentStatusEnum | null
    createdAt: string
  } | null>
  partner: {
    __typename: 'Partner'
    name?: string | null
    legalName?: string | null
    subPremise?: string | null
    city?: string | null
    state?: string | null
    postalCode?: string | null
    country?: string | null
    streetAddress?: string | null
    paymentsPortalCustomization: {
      __typename: 'PartnerPaymentsPortalCustomization'
      color?: string | null
      logoUrl?: string | null
    }
  }
  transaction?: {
    __typename: 'Transaction'
    failureReason?: string | null
  } | null
  product:
    | { __typename: 'InstantPayment' }
    | {
        __typename: 'Invoice'
        amount: number
        createdAt: string
        dueDate?: string | null
        id: string
        invoiceNumber: string
        outstandingAmount: number
        productName?: string | null
        status: InvoiceStatus
        recurringpayment: boolean
        partner?: {
          __typename: 'Partner'
          legalName?: string | null
          paymentsPortalEnabled: boolean
          paymentsPortalMethods: Array<PartnerPaymentsPortalMethod>
          paymentsPortalUrl?: string | null
          paymentsPortalCustomUrl?: string | null
          paymentsPortalUseCustomUrl?: boolean | null
          paymentsPortalDefaultUrl?: string | null
          paymentsPortalCustomInvoices?: boolean | null
          streetAddress?: string | null
          subPremise?: string | null
          city?: string | null
          state?: string | null
          postalCode?: string | null
          country?: string | null
          id: string
          name?: string | null
          paymentsPortalCustomization: {
            __typename: 'PartnerPaymentsPortalCustomization'
            color?: string | null
            logoUrl?: string | null
          }
        } | null
        offer?: {
          __typename: 'BNPLOffer'
          id: string
          amount: number
          createdAt: string
          remainingBalance: number
          netAmount: number
          terms: number
          status: BnplStatus
        } | null
        lending?: {
          __typename: 'Lending'
          installments?: Array<{
            __typename: 'Installment'
            id: string
            amount: number
            netAmount: number
            dueDate: string
            status: InstallmentStatus
            payments: Array<{
              __typename: 'Payment'
              amount: number
              netAmount: number
              creationDate: string
              currentPaymentMethod?: TransferPaymentMethodEnum | null
              transaction?: {
                __typename: 'Transaction'
                transactionMethod: TransactionMethod
              } | null
              statuses: Array<{
                __typename: 'PaymentStatus'
                status?: PaymentStatusEnum | null
                createdAt: string
              } | null>
            } | null>
          } | null> | null
        } | null
        directPayment?: {
          __typename: 'DirectPayment'
          id: string
          status: DirectPaymentStatus
          payments: Array<{
            __typename: 'Payment'
            transaction?: {
              __typename: 'Transaction'
              failureReason?: string | null
            } | null
          } | null>
        } | null
      }
    | { __typename: 'Offer' }
    | { __typename: 'SubscriptionPayment' }
}

export type GetUserEmailByKratosIdentityQueryVariables = Exact<{
  [key: string]: never
}>

export type GetUserEmailByKratosIdentityQuery = {
  __typename: 'Query'
  GetUserEmailByKratosIdentity: string
}

export type GetCustomerUsersQueryVariables = Exact<{ [key: string]: never }>

export type GetCustomerUsersQuery = {
  __typename: 'Query'
  GetCustomerUsers: Array<{
    __typename: 'CustomerUserInfo'
    id: string
    role: string
    email: string
    firstName?: string | null
    lastName?: string | null
    phone?: string | null
    jobTitle?: string | null
    createdAt: string
    permissions: Array<CustomerUserPermissions>
    customer?: {
      __typename: 'Customer'
      id: string
      name?: string | null
      legalName?: string | null
      ein?: string | null
      companyType?: string | null
      industry?: string | null
      description?: string | null
      isOnboarded: boolean
      streetAddress?: string | null
      subPremise?: string | null
      city?: string | null
      state?: string | null
      postalCode?: string | null
      country?: string | null
      createdAt: string
    } | null
  } | null>
}

export type GetUserInfoQueryVariables = Exact<{ [key: string]: never }>

export type GetUserInfoQuery = {
  __typename: 'Query'
  GetUserInfo?: {
    __typename: 'CustomerGetUserInfoReply'
    id: string
    userType: UserType
    users?: Array<{
      __typename: 'CustomerUserInfo'
      id: string
      role: string
      email: string
      firstName?: string | null
      lastName?: string | null
      phone?: string | null
      jobTitle?: string | null
      createdAt: string
      permissions: Array<CustomerUserPermissions>
      customer?: {
        __typename: 'Customer'
        id: string
        name?: string | null
        legalName?: string | null
        ein?: string | null
        companyType?: string | null
        industry?: string | null
        description?: string | null
        isOnboarded: boolean
        streetAddress?: string | null
        subPremise?: string | null
        city?: string | null
        state?: string | null
        postalCode?: string | null
        country?: string | null
        createdAt: string
      } | null
    }> | null
  } | null
}

export type GetUserTypeQueryVariables = Exact<{ [key: string]: never }>

export type GetUserTypeQuery = {
  __typename: 'Query'
  GetUserInfo?: {
    __typename: 'CustomerGetUserInfoReply'
    id: string
    userType: UserType
  } | null
}

export type UserHasKratosIdentityQueryVariables = Exact<{
  identifier: Scalars['String']['input']
}>

export type UserHasKratosIdentityQuery = {
  __typename: 'Query'
  UserHasKratosIdentity: boolean
}

export type GetUserKratosCredentialsQueryVariables = Exact<{
  identifier: Scalars['String']['input']
}>

export type GetUserKratosCredentialsQuery = {
  __typename: 'Query'
  GetUserKratosCredentials: {
    __typename: 'UserKratosCredentials'
    credentials: Array<string>
  }
}

export type CustomerUserInfoDataFragment = {
  __typename: 'CustomerUserInfo'
  id: string
  role: string
  email: string
  firstName?: string | null
  lastName?: string | null
  phone?: string | null
  jobTitle?: string | null
  createdAt: string
  permissions: Array<CustomerUserPermissions>
  customer?: {
    __typename: 'Customer'
    id: string
    name?: string | null
    legalName?: string | null
    ein?: string | null
    companyType?: string | null
    industry?: string | null
    description?: string | null
    isOnboarded: boolean
    streetAddress?: string | null
    subPremise?: string | null
    city?: string | null
    state?: string | null
    postalCode?: string | null
    country?: string | null
    createdAt: string
  } | null
}

export type CustomerInfoFragment = {
  __typename: 'Customer'
  id: string
  name?: string | null
  legalName?: string | null
  ein?: string | null
  companyType?: string | null
  industry?: string | null
  description?: string | null
  isOnboarded: boolean
  streetAddress?: string | null
  subPremise?: string | null
  city?: string | null
  state?: string | null
  postalCode?: string | null
  country?: string | null
  createdAt: string
}

export const TokenFragmentDoc = /*#__PURE__*/ gql`
  fragment Token on TokenExchange {
    access_token
    refresh_token
    expiry
    id_token
  }
`
export const CustomerAutopayRulesFragmentDoc = /*#__PURE__*/ gql`
  fragment CustomerAutopayRules on AutopayRule {
    id
    daysPastCreation
    daysPastDue
    daysBeforeDue
    amountOperator
    amount
    autotaskContractTypes {
      externalID
      partnerID
      name
    }
    connectwiseAgreementTypes {
      externalID
      partnerID
      name
    }
    haloPSAContractSubtypes {
      externalID
      partnerID
      name
    }
    quickbooksRecurringTransactions {
      externalID
      partnerID
      name
    }
    customers {
      id
      name
    }
    halopsaRecurringInvoices
    createdByCustomer
  }
`
export const BnplRateFragmentDoc = /*#__PURE__*/ gql`
  fragment BNPLRate on BNPLRateResult {
    amount
    fees
    netAmount
    rate
    term
    installment
  }
`
export const CustomerBankAccountFragmentDoc = /*#__PURE__*/ gql`
  fragment CustomerBankAccount on Account {
    id
    institution {
      id
      externalId
      name
      logo
    }
    mask
    name
    type
    subtype
    hasAchAccountNumber
    hasAchRoutingNumber
    hasWireRoutingNumber
    provider
    disconnectedAt
    systemDeactivatedAt
  }
`
export const CustomerBankFragmentDoc = /*#__PURE__*/ gql`
  fragment CustomerBank on Institution {
    id
    externalId
    name
    url
    logo
    accounts {
      ...CustomerBankAccount
    }
  }
  ${CustomerBankAccountFragmentDoc}
`
export const CustomerCreditCardFragmentDoc = /*#__PURE__*/ gql`
  fragment CustomerCreditCard on Card {
    id
    last4
    expirationDate
    cardNetWork
  }
`
export const CustomerUserBaseFragmentDoc = /*#__PURE__*/ gql`
  fragment CustomerUserBase on CustomerUser {
    id
    firstName
    lastName
    email
  }
`
export const CustomerListUserFragmentDoc = /*#__PURE__*/ gql`
  fragment CustomerListUser on CustomerUser {
    __typename
    role
    createdAt
    ...CustomerUserBase
  }
  ${CustomerUserBaseFragmentDoc}
`
export const CustomerPartnerBaseFragmentDoc = /*#__PURE__*/ gql`
  fragment CustomerPartnerBase on Partner {
    id
    name
  }
`
export const CustomerPartnerFragmentDoc = /*#__PURE__*/ gql`
  fragment CustomerPartner on Partner {
    __typename
    ...CustomerPartnerBase
    legalName
    paymentsPortalEnabled
    paymentsPortalMethods
    paymentsPortalCustomization {
      color
      logoUrl
    }
    paymentsPortalUrl
    paymentsPortalCustomUrl
    paymentsPortalUseCustomUrl
    paymentsPortalDefaultUrl
    paymentsPortalCustomInvoices
    streetAddress
    subPremise
    city
    state
    postalCode
    country
  }
  ${CustomerPartnerBaseFragmentDoc}
`
export const CustomerBnplOfferFragmentDoc = /*#__PURE__*/ gql`
  fragment CustomerBNPLOffer on BNPLOffer {
    id
    amount
    createdAt
    remainingBalance
    netAmount
    terms
    status
  }
`
export const CustomerInstallmentPaymentFragmentDoc = /*#__PURE__*/ gql`
  fragment CustomerInstallmentPayment on Payment {
    amount
    netAmount
    creationDate
    currentPaymentMethod
    transaction {
      transactionMethod
    }
    statuses {
      status
      createdAt
    }
  }
`
export const CustomerInvoiceInstallmentFragmentDoc = /*#__PURE__*/ gql`
  fragment CustomerInvoiceInstallment on Installment {
    id
    amount
    netAmount
    dueDate
    status
    payments {
      ...CustomerInstallmentPayment
    }
  }
  ${CustomerInstallmentPaymentFragmentDoc}
`
export const CustomerInvoiceFragmentDoc = /*#__PURE__*/ gql`
  fragment CustomerInvoice on Invoice {
    amount
    createdAt
    dueDate
    id
    invoiceNumber
    outstandingAmount
    partner {
      ...CustomerPartner
    }
    offer {
      ...CustomerBNPLOffer
    }
    lending {
      installments {
        ...CustomerInvoiceInstallment
      }
    }
    productName
    status
    recurringpayment
    directPayment {
      id
      status
      payments {
        transaction {
          failureReason
        }
      }
    }
  }
  ${CustomerPartnerFragmentDoc}
  ${CustomerBnplOfferFragmentDoc}
  ${CustomerInvoiceInstallmentFragmentDoc}
`
export const CustomerBasicFragmentDoc = /*#__PURE__*/ gql`
  fragment CustomerBasic on Customer {
    id
    name
    legalName
    streetAddress
    subPremise
    city
    state
    postalCode
    country
  }
`
export const CustomerFindInvoiceFragmentDoc = /*#__PURE__*/ gql`
  fragment CustomerFindInvoice on Invoice {
    ...CustomerInvoice
    customer {
      ...CustomerBasic
    }
  }
  ${CustomerInvoiceFragmentDoc}
  ${CustomerBasicFragmentDoc}
`
export const PartnerWhitelabelFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerWhitelabel on Partner {
    id
    name
    legalName
    paymentsPortalCustomization {
      color
      logoUrl
    }
    paymentsPortalUrl
  }
`
export const SupportPreferencesFragmentDoc = /*#__PURE__*/ gql`
  fragment SupportPreferences on SupportPreferences {
    partnerID
    name
    email
    phone
    firstLine
    secondLine
  }
`
export const CustomerPaymentConfigFragmentDoc = /*#__PURE__*/ gql`
  fragment CustomerPaymentConfig on PaymentCompanyConfig {
    id
    paymentMethodEntity {
      __typename
      ... on Account {
        id
        mask
        name
        institution {
          id
          logo
        }
      }
      ... on Card {
        id
        last4
        expirationDate
        cardNetWork
      }
    }
    paymentMethod
  }
`
export const CustomerPaymentFragmentDoc = /*#__PURE__*/ gql`
  fragment CustomerPayment on Payment {
    id
    dueDate
    creationDate
    netAmount
    amount
    currentPaymentMethod
    statuses {
      status
      createdAt
    }
    partner {
      name
      legalName
      subPremise
      city
      state
      postalCode
      country
      streetAddress
      paymentsPortalCustomization {
        color
        logoUrl
      }
    }
    transaction {
      failureReason
    }
    product {
      ... on Invoice {
        ...CustomerInvoice
      }
    }
  }
  ${CustomerInvoiceFragmentDoc}
`
export const CustomerInfoFragmentDoc = /*#__PURE__*/ gql`
  fragment CustomerInfo on Customer {
    id
    name
    legalName
    ein
    companyType
    industry
    description
    isOnboarded
    streetAddress
    subPremise
    city
    state
    postalCode
    country
    createdAt
  }
`
export const CustomerUserInfoDataFragmentDoc = /*#__PURE__*/ gql`
  fragment CustomerUserInfoData on CustomerUserInfo {
    id
    role
    email
    firstName
    lastName
    phone
    jobTitle
    createdAt
    permissions
    customer {
      ...CustomerInfo
    }
  }
  ${CustomerInfoFragmentDoc}
`
export const OAuth2UrlDocument = /*#__PURE__*/ gql`
  query OAuth2Url {
    OAuth2Url
  }
`

/**
 * __useOAuth2UrlQuery__
 *
 * To run a query within a React component, call `useOAuth2UrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useOAuth2UrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOAuth2UrlQuery({
 *   variables: {
 *   },
 * });
 */
export function useOAuth2UrlQuery(
  baseOptions?: Apollo.QueryHookOptions<OAuth2UrlQuery, OAuth2UrlQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<OAuth2UrlQuery, OAuth2UrlQueryVariables>(
    OAuth2UrlDocument,
    options
  )
}
export function useOAuth2UrlLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OAuth2UrlQuery,
    OAuth2UrlQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<OAuth2UrlQuery, OAuth2UrlQueryVariables>(
    OAuth2UrlDocument,
    options
  )
}
export type OAuth2UrlQueryHookResult = ReturnType<typeof useOAuth2UrlQuery>
export type OAuth2UrlLazyQueryHookResult = ReturnType<
  typeof useOAuth2UrlLazyQuery
>
export type OAuth2UrlQueryResult = Apollo.QueryResult<
  OAuth2UrlQuery,
  OAuth2UrlQueryVariables
>
export const OAuth2ExchangeDocument = /*#__PURE__*/ gql`
  mutation OAuth2Exchange($code: String!, $state: String!) {
    OAuth2Exchange(code: $code, state: $state) {
      ...Token
    }
  }
  ${TokenFragmentDoc}
`
export type OAuth2ExchangeMutationFn = Apollo.MutationFunction<
  OAuth2ExchangeMutation,
  OAuth2ExchangeMutationVariables
>

/**
 * __useOAuth2ExchangeMutation__
 *
 * To run a mutation, you first call `useOAuth2ExchangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOAuth2ExchangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [oAuth2ExchangeMutation, { data, loading, error }] = useOAuth2ExchangeMutation({
 *   variables: {
 *      code: // value for 'code'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useOAuth2ExchangeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    OAuth2ExchangeMutation,
    OAuth2ExchangeMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    OAuth2ExchangeMutation,
    OAuth2ExchangeMutationVariables
  >(OAuth2ExchangeDocument, options)
}
export type OAuth2ExchangeMutationHookResult = ReturnType<
  typeof useOAuth2ExchangeMutation
>
export type OAuth2ExchangeMutationResult =
  Apollo.MutationResult<OAuth2ExchangeMutation>
export type OAuth2ExchangeMutationOptions = Apollo.BaseMutationOptions<
  OAuth2ExchangeMutation,
  OAuth2ExchangeMutationVariables
>
export const OAuth2RefreshDocument = /*#__PURE__*/ gql`
  mutation OAuth2Refresh($refreshToken: String!) {
    OAuth2Refresh(refreshToken: $refreshToken) {
      ...Token
    }
  }
  ${TokenFragmentDoc}
`
export type OAuth2RefreshMutationFn = Apollo.MutationFunction<
  OAuth2RefreshMutation,
  OAuth2RefreshMutationVariables
>

/**
 * __useOAuth2RefreshMutation__
 *
 * To run a mutation, you first call `useOAuth2RefreshMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOAuth2RefreshMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [oAuth2RefreshMutation, { data, loading, error }] = useOAuth2RefreshMutation({
 *   variables: {
 *      refreshToken: // value for 'refreshToken'
 *   },
 * });
 */
export function useOAuth2RefreshMutation(
  baseOptions?: Apollo.MutationHookOptions<
    OAuth2RefreshMutation,
    OAuth2RefreshMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    OAuth2RefreshMutation,
    OAuth2RefreshMutationVariables
  >(OAuth2RefreshDocument, options)
}
export type OAuth2RefreshMutationHookResult = ReturnType<
  typeof useOAuth2RefreshMutation
>
export type OAuth2RefreshMutationResult =
  Apollo.MutationResult<OAuth2RefreshMutation>
export type OAuth2RefreshMutationOptions = Apollo.BaseMutationOptions<
  OAuth2RefreshMutation,
  OAuth2RefreshMutationVariables
>
export const CustomerAutopayRuleConnectionDocument = /*#__PURE__*/ gql`
  query CustomerAutopayRuleConnection(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $orderBy: AutopayRuleOrderBy
  ) {
    CustomerAutopayRuleConnection(
      after: $after
      first: $first
      before: $before
      last: $last
      orderBy: $orderBy
    ) {
      edges {
        node {
          ...CustomerAutopayRules
        }
        cursor
      }
      pageInfo {
        hasPreviousPage
        endCursor
      }
    }
  }
  ${CustomerAutopayRulesFragmentDoc}
`

/**
 * __useCustomerAutopayRuleConnectionQuery__
 *
 * To run a query within a React component, call `useCustomerAutopayRuleConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerAutopayRuleConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerAutopayRuleConnectionQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useCustomerAutopayRuleConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CustomerAutopayRuleConnectionQuery,
    CustomerAutopayRuleConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CustomerAutopayRuleConnectionQuery,
    CustomerAutopayRuleConnectionQueryVariables
  >(CustomerAutopayRuleConnectionDocument, options)
}
export function useCustomerAutopayRuleConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CustomerAutopayRuleConnectionQuery,
    CustomerAutopayRuleConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CustomerAutopayRuleConnectionQuery,
    CustomerAutopayRuleConnectionQueryVariables
  >(CustomerAutopayRuleConnectionDocument, options)
}
export type CustomerAutopayRuleConnectionQueryHookResult = ReturnType<
  typeof useCustomerAutopayRuleConnectionQuery
>
export type CustomerAutopayRuleConnectionLazyQueryHookResult = ReturnType<
  typeof useCustomerAutopayRuleConnectionLazyQuery
>
export type CustomerAutopayRuleConnectionQueryResult = Apollo.QueryResult<
  CustomerAutopayRuleConnectionQuery,
  CustomerAutopayRuleConnectionQueryVariables
>
export const CustomerCreateAutopayRuleDocument = /*#__PURE__*/ gql`
  mutation CustomerCreateAutopayRule($input: CustomerCreateAutopayRuleInput!) {
    CustomerCreateAutopayRule(input: $input) {
      ...CustomerAutopayRules
    }
  }
  ${CustomerAutopayRulesFragmentDoc}
`
export type CustomerCreateAutopayRuleMutationFn = Apollo.MutationFunction<
  CustomerCreateAutopayRuleMutation,
  CustomerCreateAutopayRuleMutationVariables
>

/**
 * __useCustomerCreateAutopayRuleMutation__
 *
 * To run a mutation, you first call `useCustomerCreateAutopayRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerCreateAutopayRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerCreateAutopayRuleMutation, { data, loading, error }] = useCustomerCreateAutopayRuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomerCreateAutopayRuleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CustomerCreateAutopayRuleMutation,
    CustomerCreateAutopayRuleMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CustomerCreateAutopayRuleMutation,
    CustomerCreateAutopayRuleMutationVariables
  >(CustomerCreateAutopayRuleDocument, options)
}
export type CustomerCreateAutopayRuleMutationHookResult = ReturnType<
  typeof useCustomerCreateAutopayRuleMutation
>
export type CustomerCreateAutopayRuleMutationResult =
  Apollo.MutationResult<CustomerCreateAutopayRuleMutation>
export type CustomerCreateAutopayRuleMutationOptions =
  Apollo.BaseMutationOptions<
    CustomerCreateAutopayRuleMutation,
    CustomerCreateAutopayRuleMutationVariables
  >
export const CustomerAutopayExcludedCustomerCreateDocument = /*#__PURE__*/ gql`
  mutation CustomerAutopayExcludedCustomerCreate {
    CustomerAutopayExcludedCustomerCreate {
      id
      customer {
        id
        name
      }
    }
  }
`
export type CustomerAutopayExcludedCustomerCreateMutationFn =
  Apollo.MutationFunction<
    CustomerAutopayExcludedCustomerCreateMutation,
    CustomerAutopayExcludedCustomerCreateMutationVariables
  >

/**
 * __useCustomerAutopayExcludedCustomerCreateMutation__
 *
 * To run a mutation, you first call `useCustomerAutopayExcludedCustomerCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerAutopayExcludedCustomerCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerAutopayExcludedCustomerCreateMutation, { data, loading, error }] = useCustomerAutopayExcludedCustomerCreateMutation({
 *   variables: {
 *   },
 * });
 */
export function useCustomerAutopayExcludedCustomerCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CustomerAutopayExcludedCustomerCreateMutation,
    CustomerAutopayExcludedCustomerCreateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CustomerAutopayExcludedCustomerCreateMutation,
    CustomerAutopayExcludedCustomerCreateMutationVariables
  >(CustomerAutopayExcludedCustomerCreateDocument, options)
}
export type CustomerAutopayExcludedCustomerCreateMutationHookResult =
  ReturnType<typeof useCustomerAutopayExcludedCustomerCreateMutation>
export type CustomerAutopayExcludedCustomerCreateMutationResult =
  Apollo.MutationResult<CustomerAutopayExcludedCustomerCreateMutation>
export type CustomerAutopayExcludedCustomerCreateMutationOptions =
  Apollo.BaseMutationOptions<
    CustomerAutopayExcludedCustomerCreateMutation,
    CustomerAutopayExcludedCustomerCreateMutationVariables
  >
export const CustomerInvoiceBnplTotalsDocument = /*#__PURE__*/ gql`
  query CustomerInvoiceBnplTotals($filters: BnplFilter) {
    CustomerInvoiceBnplTotals(filters: $filters) {
      count
      offerAmount
      invoiceAmount
    }
  }
`

/**
 * __useCustomerInvoiceBnplTotalsQuery__
 *
 * To run a query within a React component, call `useCustomerInvoiceBnplTotalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerInvoiceBnplTotalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerInvoiceBnplTotalsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useCustomerInvoiceBnplTotalsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CustomerInvoiceBnplTotalsQuery,
    CustomerInvoiceBnplTotalsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CustomerInvoiceBnplTotalsQuery,
    CustomerInvoiceBnplTotalsQueryVariables
  >(CustomerInvoiceBnplTotalsDocument, options)
}
export function useCustomerInvoiceBnplTotalsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CustomerInvoiceBnplTotalsQuery,
    CustomerInvoiceBnplTotalsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CustomerInvoiceBnplTotalsQuery,
    CustomerInvoiceBnplTotalsQueryVariables
  >(CustomerInvoiceBnplTotalsDocument, options)
}
export type CustomerInvoiceBnplTotalsQueryHookResult = ReturnType<
  typeof useCustomerInvoiceBnplTotalsQuery
>
export type CustomerInvoiceBnplTotalsLazyQueryHookResult = ReturnType<
  typeof useCustomerInvoiceBnplTotalsLazyQuery
>
export type CustomerInvoiceBnplTotalsQueryResult = Apollo.QueryResult<
  CustomerInvoiceBnplTotalsQuery,
  CustomerInvoiceBnplTotalsQueryVariables
>
export const CustomerInvoiceBnplConnectionDocument = /*#__PURE__*/ gql`
  query CustomerInvoiceBnplConnection(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $filters: BnplFilter
  ) {
    CustomerInvoiceBnplConnection(
      after: $after
      first: $first
      before: $before
      last: $last
      filters: $filters
    ) {
      edges {
        node {
          ...CustomerInvoice
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
  ${CustomerInvoiceFragmentDoc}
`

/**
 * __useCustomerInvoiceBnplConnectionQuery__
 *
 * To run a query within a React component, call `useCustomerInvoiceBnplConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerInvoiceBnplConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerInvoiceBnplConnectionQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useCustomerInvoiceBnplConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CustomerInvoiceBnplConnectionQuery,
    CustomerInvoiceBnplConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CustomerInvoiceBnplConnectionQuery,
    CustomerInvoiceBnplConnectionQueryVariables
  >(CustomerInvoiceBnplConnectionDocument, options)
}
export function useCustomerInvoiceBnplConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CustomerInvoiceBnplConnectionQuery,
    CustomerInvoiceBnplConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CustomerInvoiceBnplConnectionQuery,
    CustomerInvoiceBnplConnectionQueryVariables
  >(CustomerInvoiceBnplConnectionDocument, options)
}
export type CustomerInvoiceBnplConnectionQueryHookResult = ReturnType<
  typeof useCustomerInvoiceBnplConnectionQuery
>
export type CustomerInvoiceBnplConnectionLazyQueryHookResult = ReturnType<
  typeof useCustomerInvoiceBnplConnectionLazyQuery
>
export type CustomerInvoiceBnplConnectionQueryResult = Apollo.QueryResult<
  CustomerInvoiceBnplConnectionQuery,
  CustomerInvoiceBnplConnectionQueryVariables
>
export const CustomerBnplOfferCreateDocument = /*#__PURE__*/ gql`
  mutation CustomerBNPLOfferCreate($input: BNPLCreateInput) {
    CustomerBNPLOfferCreate(input: $input)
  }
`
export type CustomerBnplOfferCreateMutationFn = Apollo.MutationFunction<
  CustomerBnplOfferCreateMutation,
  CustomerBnplOfferCreateMutationVariables
>

/**
 * __useCustomerBnplOfferCreateMutation__
 *
 * To run a mutation, you first call `useCustomerBnplOfferCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerBnplOfferCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerBnplOfferCreateMutation, { data, loading, error }] = useCustomerBnplOfferCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomerBnplOfferCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CustomerBnplOfferCreateMutation,
    CustomerBnplOfferCreateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CustomerBnplOfferCreateMutation,
    CustomerBnplOfferCreateMutationVariables
  >(CustomerBnplOfferCreateDocument, options)
}
export type CustomerBnplOfferCreateMutationHookResult = ReturnType<
  typeof useCustomerBnplOfferCreateMutation
>
export type CustomerBnplOfferCreateMutationResult =
  Apollo.MutationResult<CustomerBnplOfferCreateMutation>
export type CustomerBnplOfferCreateMutationOptions = Apollo.BaseMutationOptions<
  CustomerBnplOfferCreateMutation,
  CustomerBnplOfferCreateMutationVariables
>
export const GetRateDocument = /*#__PURE__*/ gql`
  mutation GetRate($input: BNPLGetRateInput) {
    CustomerBNPLOfferGetRate(input: $input) {
      ...BNPLRate
    }
  }
  ${BnplRateFragmentDoc}
`
export type GetRateMutationFn = Apollo.MutationFunction<
  GetRateMutation,
  GetRateMutationVariables
>

/**
 * __useGetRateMutation__
 *
 * To run a mutation, you first call `useGetRateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetRateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getRateMutation, { data, loading, error }] = useGetRateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetRateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GetRateMutation,
    GetRateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<GetRateMutation, GetRateMutationVariables>(
    GetRateDocument,
    options
  )
}
export type GetRateMutationHookResult = ReturnType<typeof useGetRateMutation>
export type GetRateMutationResult = Apollo.MutationResult<GetRateMutation>
export type GetRateMutationOptions = Apollo.BaseMutationOptions<
  GetRateMutation,
  GetRateMutationVariables
>
export const CustomerListBankingIntegrationsDocument = /*#__PURE__*/ gql`
  query CustomerListBankingIntegrations {
    CustomerListBankingIntegrations {
      ...CustomerBank
    }
  }
  ${CustomerBankFragmentDoc}
`

/**
 * __useCustomerListBankingIntegrationsQuery__
 *
 * To run a query within a React component, call `useCustomerListBankingIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerListBankingIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerListBankingIntegrationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomerListBankingIntegrationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CustomerListBankingIntegrationsQuery,
    CustomerListBankingIntegrationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CustomerListBankingIntegrationsQuery,
    CustomerListBankingIntegrationsQueryVariables
  >(CustomerListBankingIntegrationsDocument, options)
}
export function useCustomerListBankingIntegrationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CustomerListBankingIntegrationsQuery,
    CustomerListBankingIntegrationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CustomerListBankingIntegrationsQuery,
    CustomerListBankingIntegrationsQueryVariables
  >(CustomerListBankingIntegrationsDocument, options)
}
export type CustomerListBankingIntegrationsQueryHookResult = ReturnType<
  typeof useCustomerListBankingIntegrationsQuery
>
export type CustomerListBankingIntegrationsLazyQueryHookResult = ReturnType<
  typeof useCustomerListBankingIntegrationsLazyQuery
>
export type CustomerListBankingIntegrationsQueryResult = Apollo.QueryResult<
  CustomerListBankingIntegrationsQuery,
  CustomerListBankingIntegrationsQueryVariables
>
export const CustomerGetLinkTokenDocument = /*#__PURE__*/ gql`
  query CustomerGetLinkToken($redirectURI: String!) {
    CustomerGetLinkToken(redirectURI: $redirectURI)
  }
`

/**
 * __useCustomerGetLinkTokenQuery__
 *
 * To run a query within a React component, call `useCustomerGetLinkTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerGetLinkTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerGetLinkTokenQuery({
 *   variables: {
 *      redirectURI: // value for 'redirectURI'
 *   },
 * });
 */
export function useCustomerGetLinkTokenQuery(
  baseOptions: Apollo.QueryHookOptions<
    CustomerGetLinkTokenQuery,
    CustomerGetLinkTokenQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CustomerGetLinkTokenQuery,
    CustomerGetLinkTokenQueryVariables
  >(CustomerGetLinkTokenDocument, options)
}
export function useCustomerGetLinkTokenLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CustomerGetLinkTokenQuery,
    CustomerGetLinkTokenQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CustomerGetLinkTokenQuery,
    CustomerGetLinkTokenQueryVariables
  >(CustomerGetLinkTokenDocument, options)
}
export type CustomerGetLinkTokenQueryHookResult = ReturnType<
  typeof useCustomerGetLinkTokenQuery
>
export type CustomerGetLinkTokenLazyQueryHookResult = ReturnType<
  typeof useCustomerGetLinkTokenLazyQuery
>
export type CustomerGetLinkTokenQueryResult = Apollo.QueryResult<
  CustomerGetLinkTokenQuery,
  CustomerGetLinkTokenQueryVariables
>
export const CustomerArchiveAccountDocument = /*#__PURE__*/ gql`
  mutation CustomerArchiveAccount($accountID: ID!) {
    CustomerArchiveAccount(accountID: $accountID)
  }
`
export type CustomerArchiveAccountMutationFn = Apollo.MutationFunction<
  CustomerArchiveAccountMutation,
  CustomerArchiveAccountMutationVariables
>

/**
 * __useCustomerArchiveAccountMutation__
 *
 * To run a mutation, you first call `useCustomerArchiveAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerArchiveAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerArchiveAccountMutation, { data, loading, error }] = useCustomerArchiveAccountMutation({
 *   variables: {
 *      accountID: // value for 'accountID'
 *   },
 * });
 */
export function useCustomerArchiveAccountMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CustomerArchiveAccountMutation,
    CustomerArchiveAccountMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CustomerArchiveAccountMutation,
    CustomerArchiveAccountMutationVariables
  >(CustomerArchiveAccountDocument, options)
}
export type CustomerArchiveAccountMutationHookResult = ReturnType<
  typeof useCustomerArchiveAccountMutation
>
export type CustomerArchiveAccountMutationResult =
  Apollo.MutationResult<CustomerArchiveAccountMutation>
export type CustomerArchiveAccountMutationOptions = Apollo.BaseMutationOptions<
  CustomerArchiveAccountMutation,
  CustomerArchiveAccountMutationVariables
>
export const CustomerAddManualBankingConnectionDocument = /*#__PURE__*/ gql`
  mutation CustomerAddManualBankingConnection(
    $accountInformation: ManualBankingAccountInformationInput!
  ) {
    CustomerAddManualBankingConnection(accountInformation: $accountInformation)
  }
`
export type CustomerAddManualBankingConnectionMutationFn =
  Apollo.MutationFunction<
    CustomerAddManualBankingConnectionMutation,
    CustomerAddManualBankingConnectionMutationVariables
  >

/**
 * __useCustomerAddManualBankingConnectionMutation__
 *
 * To run a mutation, you first call `useCustomerAddManualBankingConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerAddManualBankingConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerAddManualBankingConnectionMutation, { data, loading, error }] = useCustomerAddManualBankingConnectionMutation({
 *   variables: {
 *      accountInformation: // value for 'accountInformation'
 *   },
 * });
 */
export function useCustomerAddManualBankingConnectionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CustomerAddManualBankingConnectionMutation,
    CustomerAddManualBankingConnectionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CustomerAddManualBankingConnectionMutation,
    CustomerAddManualBankingConnectionMutationVariables
  >(CustomerAddManualBankingConnectionDocument, options)
}
export type CustomerAddManualBankingConnectionMutationHookResult = ReturnType<
  typeof useCustomerAddManualBankingConnectionMutation
>
export type CustomerAddManualBankingConnectionMutationResult =
  Apollo.MutationResult<CustomerAddManualBankingConnectionMutation>
export type CustomerAddManualBankingConnectionMutationOptions =
  Apollo.BaseMutationOptions<
    CustomerAddManualBankingConnectionMutation,
    CustomerAddManualBankingConnectionMutationVariables
  >
export const CustomerAddPlaidConnectionDocument = /*#__PURE__*/ gql`
  mutation CustomerAddPlaidConnection(
    $publicToken: String!
    $institutionId: String
    $accountIds: [String!]!
  ) {
    CustomerAddPlaidBankingConnection(
      publicToken: $publicToken
      institutionId: $institutionId
      accountIds: $accountIds
    )
  }
`
export type CustomerAddPlaidConnectionMutationFn = Apollo.MutationFunction<
  CustomerAddPlaidConnectionMutation,
  CustomerAddPlaidConnectionMutationVariables
>

/**
 * __useCustomerAddPlaidConnectionMutation__
 *
 * To run a mutation, you first call `useCustomerAddPlaidConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerAddPlaidConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerAddPlaidConnectionMutation, { data, loading, error }] = useCustomerAddPlaidConnectionMutation({
 *   variables: {
 *      publicToken: // value for 'publicToken'
 *      institutionId: // value for 'institutionId'
 *      accountIds: // value for 'accountIds'
 *   },
 * });
 */
export function useCustomerAddPlaidConnectionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CustomerAddPlaidConnectionMutation,
    CustomerAddPlaidConnectionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CustomerAddPlaidConnectionMutation,
    CustomerAddPlaidConnectionMutationVariables
  >(CustomerAddPlaidConnectionDocument, options)
}
export type CustomerAddPlaidConnectionMutationHookResult = ReturnType<
  typeof useCustomerAddPlaidConnectionMutation
>
export type CustomerAddPlaidConnectionMutationResult =
  Apollo.MutationResult<CustomerAddPlaidConnectionMutation>
export type CustomerAddPlaidConnectionMutationOptions =
  Apollo.BaseMutationOptions<
    CustomerAddPlaidConnectionMutation,
    CustomerAddPlaidConnectionMutationVariables
  >
export const CustomerListCardsDocument = /*#__PURE__*/ gql`
  query CustomerListCards($filter: ListCardsFilterInput) {
    CustomerListCards(filter: $filter) {
      ...CustomerCreditCard
    }
  }
  ${CustomerCreditCardFragmentDoc}
`

/**
 * __useCustomerListCardsQuery__
 *
 * To run a query within a React component, call `useCustomerListCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerListCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerListCardsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCustomerListCardsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CustomerListCardsQuery,
    CustomerListCardsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CustomerListCardsQuery,
    CustomerListCardsQueryVariables
  >(CustomerListCardsDocument, options)
}
export function useCustomerListCardsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CustomerListCardsQuery,
    CustomerListCardsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CustomerListCardsQuery,
    CustomerListCardsQueryVariables
  >(CustomerListCardsDocument, options)
}
export type CustomerListCardsQueryHookResult = ReturnType<
  typeof useCustomerListCardsQuery
>
export type CustomerListCardsLazyQueryHookResult = ReturnType<
  typeof useCustomerListCardsLazyQuery
>
export type CustomerListCardsQueryResult = Apollo.QueryResult<
  CustomerListCardsQuery,
  CustomerListCardsQueryVariables
>
export const CustomerGetCardPubKeyDocument = /*#__PURE__*/ gql`
  query CustomerGetCardPubKey($input: GetCardPubKey!) {
    CustomerGetCardPubKey(input: $input)
  }
`

/**
 * __useCustomerGetCardPubKeyQuery__
 *
 * To run a query within a React component, call `useCustomerGetCardPubKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerGetCardPubKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerGetCardPubKeyQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomerGetCardPubKeyQuery(
  baseOptions: Apollo.QueryHookOptions<
    CustomerGetCardPubKeyQuery,
    CustomerGetCardPubKeyQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CustomerGetCardPubKeyQuery,
    CustomerGetCardPubKeyQueryVariables
  >(CustomerGetCardPubKeyDocument, options)
}
export function useCustomerGetCardPubKeyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CustomerGetCardPubKeyQuery,
    CustomerGetCardPubKeyQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CustomerGetCardPubKeyQuery,
    CustomerGetCardPubKeyQueryVariables
  >(CustomerGetCardPubKeyDocument, options)
}
export type CustomerGetCardPubKeyQueryHookResult = ReturnType<
  typeof useCustomerGetCardPubKeyQuery
>
export type CustomerGetCardPubKeyLazyQueryHookResult = ReturnType<
  typeof useCustomerGetCardPubKeyLazyQuery
>
export type CustomerGetCardPubKeyQueryResult = Apollo.QueryResult<
  CustomerGetCardPubKeyQuery,
  CustomerGetCardPubKeyQueryVariables
>
export const CustomerGetCardFeeDocument = /*#__PURE__*/ gql`
  query CustomerGetCardFee($input: GetCardFeeInput!) {
    CustomerGetCardFee(input: $input) {
      percentage
      feeAmount
    }
  }
`

/**
 * __useCustomerGetCardFeeQuery__
 *
 * To run a query within a React component, call `useCustomerGetCardFeeQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerGetCardFeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerGetCardFeeQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomerGetCardFeeQuery(
  baseOptions: Apollo.QueryHookOptions<
    CustomerGetCardFeeQuery,
    CustomerGetCardFeeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CustomerGetCardFeeQuery,
    CustomerGetCardFeeQueryVariables
  >(CustomerGetCardFeeDocument, options)
}
export function useCustomerGetCardFeeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CustomerGetCardFeeQuery,
    CustomerGetCardFeeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CustomerGetCardFeeQuery,
    CustomerGetCardFeeQueryVariables
  >(CustomerGetCardFeeDocument, options)
}
export type CustomerGetCardFeeQueryHookResult = ReturnType<
  typeof useCustomerGetCardFeeQuery
>
export type CustomerGetCardFeeLazyQueryHookResult = ReturnType<
  typeof useCustomerGetCardFeeLazyQuery
>
export type CustomerGetCardFeeQueryResult = Apollo.QueryResult<
  CustomerGetCardFeeQuery,
  CustomerGetCardFeeQueryVariables
>
export const CustomerGetCardFeesDocument = /*#__PURE__*/ gql`
  query CustomerGetCardFees {
    CustomerGetCardFees {
      percentage
      cardNetwork
    }
  }
`

/**
 * __useCustomerGetCardFeesQuery__
 *
 * To run a query within a React component, call `useCustomerGetCardFeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerGetCardFeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerGetCardFeesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomerGetCardFeesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CustomerGetCardFeesQuery,
    CustomerGetCardFeesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CustomerGetCardFeesQuery,
    CustomerGetCardFeesQueryVariables
  >(CustomerGetCardFeesDocument, options)
}
export function useCustomerGetCardFeesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CustomerGetCardFeesQuery,
    CustomerGetCardFeesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CustomerGetCardFeesQuery,
    CustomerGetCardFeesQueryVariables
  >(CustomerGetCardFeesDocument, options)
}
export type CustomerGetCardFeesQueryHookResult = ReturnType<
  typeof useCustomerGetCardFeesQuery
>
export type CustomerGetCardFeesLazyQueryHookResult = ReturnType<
  typeof useCustomerGetCardFeesLazyQuery
>
export type CustomerGetCardFeesQueryResult = Apollo.QueryResult<
  CustomerGetCardFeesQuery,
  CustomerGetCardFeesQueryVariables
>
export const CustomerCreateCardDocument = /*#__PURE__*/ gql`
  mutation CustomerCreateCard($input: CardCreationInput!) {
    CustomerCreateCard(input: $input)
  }
`
export type CustomerCreateCardMutationFn = Apollo.MutationFunction<
  CustomerCreateCardMutation,
  CustomerCreateCardMutationVariables
>

/**
 * __useCustomerCreateCardMutation__
 *
 * To run a mutation, you first call `useCustomerCreateCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerCreateCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerCreateCardMutation, { data, loading, error }] = useCustomerCreateCardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomerCreateCardMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CustomerCreateCardMutation,
    CustomerCreateCardMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CustomerCreateCardMutation,
    CustomerCreateCardMutationVariables
  >(CustomerCreateCardDocument, options)
}
export type CustomerCreateCardMutationHookResult = ReturnType<
  typeof useCustomerCreateCardMutation
>
export type CustomerCreateCardMutationResult =
  Apollo.MutationResult<CustomerCreateCardMutation>
export type CustomerCreateCardMutationOptions = Apollo.BaseMutationOptions<
  CustomerCreateCardMutation,
  CustomerCreateCardMutationVariables
>
export const CustomerDeleteCardDocument = /*#__PURE__*/ gql`
  mutation CustomerDeleteCard($input: CardDeletionInput!) {
    CustomerDeleteCard(input: $input)
  }
`
export type CustomerDeleteCardMutationFn = Apollo.MutationFunction<
  CustomerDeleteCardMutation,
  CustomerDeleteCardMutationVariables
>

/**
 * __useCustomerDeleteCardMutation__
 *
 * To run a mutation, you first call `useCustomerDeleteCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerDeleteCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerDeleteCardMutation, { data, loading, error }] = useCustomerDeleteCardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomerDeleteCardMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CustomerDeleteCardMutation,
    CustomerDeleteCardMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CustomerDeleteCardMutation,
    CustomerDeleteCardMutationVariables
  >(CustomerDeleteCardDocument, options)
}
export type CustomerDeleteCardMutationHookResult = ReturnType<
  typeof useCustomerDeleteCardMutation
>
export type CustomerDeleteCardMutationResult =
  Apollo.MutationResult<CustomerDeleteCardMutation>
export type CustomerDeleteCardMutationOptions = Apollo.BaseMutationOptions<
  CustomerDeleteCardMutation,
  CustomerDeleteCardMutationVariables
>
export const CustomerModernBancGenerateSerializedTokenDocument = /*#__PURE__*/ gql`
  mutation CustomerModernBancGenerateSerializedToken(
    $input: CardSerializationInput!
  ) {
    CustomerModernBancGenerateSerializedToken(input: $input)
  }
`
export type CustomerModernBancGenerateSerializedTokenMutationFn =
  Apollo.MutationFunction<
    CustomerModernBancGenerateSerializedTokenMutation,
    CustomerModernBancGenerateSerializedTokenMutationVariables
  >

/**
 * __useCustomerModernBancGenerateSerializedTokenMutation__
 *
 * To run a mutation, you first call `useCustomerModernBancGenerateSerializedTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerModernBancGenerateSerializedTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerModernBancGenerateSerializedTokenMutation, { data, loading, error }] = useCustomerModernBancGenerateSerializedTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomerModernBancGenerateSerializedTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CustomerModernBancGenerateSerializedTokenMutation,
    CustomerModernBancGenerateSerializedTokenMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CustomerModernBancGenerateSerializedTokenMutation,
    CustomerModernBancGenerateSerializedTokenMutationVariables
  >(CustomerModernBancGenerateSerializedTokenDocument, options)
}
export type CustomerModernBancGenerateSerializedTokenMutationHookResult =
  ReturnType<typeof useCustomerModernBancGenerateSerializedTokenMutation>
export type CustomerModernBancGenerateSerializedTokenMutationResult =
  Apollo.MutationResult<CustomerModernBancGenerateSerializedTokenMutation>
export type CustomerModernBancGenerateSerializedTokenMutationOptions =
  Apollo.BaseMutationOptions<
    CustomerModernBancGenerateSerializedTokenMutation,
    CustomerModernBancGenerateSerializedTokenMutationVariables
  >
export const CustomerRequestAccessDocument = /*#__PURE__*/ gql`
  mutation CustomerRequestAccess {
    CustomerRequestAccess
  }
`
export type CustomerRequestAccessMutationFn = Apollo.MutationFunction<
  CustomerRequestAccessMutation,
  CustomerRequestAccessMutationVariables
>

/**
 * __useCustomerRequestAccessMutation__
 *
 * To run a mutation, you first call `useCustomerRequestAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerRequestAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerRequestAccessMutation, { data, loading, error }] = useCustomerRequestAccessMutation({
 *   variables: {
 *   },
 * });
 */
export function useCustomerRequestAccessMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CustomerRequestAccessMutation,
    CustomerRequestAccessMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CustomerRequestAccessMutation,
    CustomerRequestAccessMutationVariables
  >(CustomerRequestAccessDocument, options)
}
export type CustomerRequestAccessMutationHookResult = ReturnType<
  typeof useCustomerRequestAccessMutation
>
export type CustomerRequestAccessMutationResult =
  Apollo.MutationResult<CustomerRequestAccessMutation>
export type CustomerRequestAccessMutationOptions = Apollo.BaseMutationOptions<
  CustomerRequestAccessMutation,
  CustomerRequestAccessMutationVariables
>
export const GetUserCustomersDocument = /*#__PURE__*/ gql`
  query GetUserCustomers {
    GetUserCustomers {
      ...CustomerBasic
    }
  }
  ${CustomerBasicFragmentDoc}
`

/**
 * __useGetUserCustomersQuery__
 *
 * To run a query within a React component, call `useGetUserCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserCustomersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserCustomersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetUserCustomersQuery,
    GetUserCustomersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetUserCustomersQuery, GetUserCustomersQueryVariables>(
    GetUserCustomersDocument,
    options
  )
}
export function useGetUserCustomersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUserCustomersQuery,
    GetUserCustomersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetUserCustomersQuery,
    GetUserCustomersQueryVariables
  >(GetUserCustomersDocument, options)
}
export type GetUserCustomersQueryHookResult = ReturnType<
  typeof useGetUserCustomersQuery
>
export type GetUserCustomersLazyQueryHookResult = ReturnType<
  typeof useGetUserCustomersLazyQuery
>
export type GetUserCustomersQueryResult = Apollo.QueryResult<
  GetUserCustomersQuery,
  GetUserCustomersQueryVariables
>
export const GetCustomerUserTeamsDocument = /*#__PURE__*/ gql`
  query GetCustomerUserTeams {
    GetCustomerUserTeams {
      portals {
        partner {
          id
          name
          paymentsPortalUrl
        }
        teams {
          id
          name
        }
      }
    }
  }
`

/**
 * __useGetCustomerUserTeamsQuery__
 *
 * To run a query within a React component, call `useGetCustomerUserTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerUserTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerUserTeamsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCustomerUserTeamsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCustomerUserTeamsQuery,
    GetCustomerUserTeamsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetCustomerUserTeamsQuery,
    GetCustomerUserTeamsQueryVariables
  >(GetCustomerUserTeamsDocument, options)
}
export function useGetCustomerUserTeamsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCustomerUserTeamsQuery,
    GetCustomerUserTeamsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetCustomerUserTeamsQuery,
    GetCustomerUserTeamsQueryVariables
  >(GetCustomerUserTeamsDocument, options)
}
export type GetCustomerUserTeamsQueryHookResult = ReturnType<
  typeof useGetCustomerUserTeamsQuery
>
export type GetCustomerUserTeamsLazyQueryHookResult = ReturnType<
  typeof useGetCustomerUserTeamsLazyQuery
>
export type GetCustomerUserTeamsQueryResult = Apollo.QueryResult<
  GetCustomerUserTeamsQuery,
  GetCustomerUserTeamsQueryVariables
>
export const CustomerUserConnectionDocument = /*#__PURE__*/ gql`
  query CustomerUserConnection(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $orderBy: CustomerUserOrderBy
  ) {
    CustomerUserConnection(
      after: $after
      first: $first
      before: $before
      last: $last
      orderBy: $orderBy
    ) {
      edges {
        node {
          ...CustomerListUser
        }
      }
    }
  }
  ${CustomerListUserFragmentDoc}
`

/**
 * __useCustomerUserConnectionQuery__
 *
 * To run a query within a React component, call `useCustomerUserConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerUserConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerUserConnectionQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useCustomerUserConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CustomerUserConnectionQuery,
    CustomerUserConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CustomerUserConnectionQuery,
    CustomerUserConnectionQueryVariables
  >(CustomerUserConnectionDocument, options)
}
export function useCustomerUserConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CustomerUserConnectionQuery,
    CustomerUserConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CustomerUserConnectionQuery,
    CustomerUserConnectionQueryVariables
  >(CustomerUserConnectionDocument, options)
}
export type CustomerUserConnectionQueryHookResult = ReturnType<
  typeof useCustomerUserConnectionQuery
>
export type CustomerUserConnectionLazyQueryHookResult = ReturnType<
  typeof useCustomerUserConnectionLazyQuery
>
export type CustomerUserConnectionQueryResult = Apollo.QueryResult<
  CustomerUserConnectionQuery,
  CustomerUserConnectionQueryVariables
>
export const CustomerFinishOnboardingDocument = /*#__PURE__*/ gql`
  mutation CustomerFinishOnboarding {
    CustomerFinishOnboarding {
      id
      isOnboarded
    }
  }
`
export type CustomerFinishOnboardingMutationFn = Apollo.MutationFunction<
  CustomerFinishOnboardingMutation,
  CustomerFinishOnboardingMutationVariables
>

/**
 * __useCustomerFinishOnboardingMutation__
 *
 * To run a mutation, you first call `useCustomerFinishOnboardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerFinishOnboardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerFinishOnboardingMutation, { data, loading, error }] = useCustomerFinishOnboardingMutation({
 *   variables: {
 *   },
 * });
 */
export function useCustomerFinishOnboardingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CustomerFinishOnboardingMutation,
    CustomerFinishOnboardingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CustomerFinishOnboardingMutation,
    CustomerFinishOnboardingMutationVariables
  >(CustomerFinishOnboardingDocument, options)
}
export type CustomerFinishOnboardingMutationHookResult = ReturnType<
  typeof useCustomerFinishOnboardingMutation
>
export type CustomerFinishOnboardingMutationResult =
  Apollo.MutationResult<CustomerFinishOnboardingMutation>
export type CustomerFinishOnboardingMutationOptions =
  Apollo.BaseMutationOptions<
    CustomerFinishOnboardingMutation,
    CustomerFinishOnboardingMutationVariables
  >
export const CustomerDeleteUserDocument = /*#__PURE__*/ gql`
  mutation CustomerDeleteUser($id: String!) {
    CustomerDeleteUser(id: $id)
  }
`
export type CustomerDeleteUserMutationFn = Apollo.MutationFunction<
  CustomerDeleteUserMutation,
  CustomerDeleteUserMutationVariables
>

/**
 * __useCustomerDeleteUserMutation__
 *
 * To run a mutation, you first call `useCustomerDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerDeleteUserMutation, { data, loading, error }] = useCustomerDeleteUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomerDeleteUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CustomerDeleteUserMutation,
    CustomerDeleteUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CustomerDeleteUserMutation,
    CustomerDeleteUserMutationVariables
  >(CustomerDeleteUserDocument, options)
}
export type CustomerDeleteUserMutationHookResult = ReturnType<
  typeof useCustomerDeleteUserMutation
>
export type CustomerDeleteUserMutationResult =
  Apollo.MutationResult<CustomerDeleteUserMutation>
export type CustomerDeleteUserMutationOptions = Apollo.BaseMutationOptions<
  CustomerDeleteUserMutation,
  CustomerDeleteUserMutationVariables
>
export const CustomerUpdateUserDocument = /*#__PURE__*/ gql`
  mutation CustomerUpdateUser($input: CustomerUpdateUserInput) {
    CustomerUpdateUser(input: $input) {
      ...CustomerUserBase
    }
  }
  ${CustomerUserBaseFragmentDoc}
`
export type CustomerUpdateUserMutationFn = Apollo.MutationFunction<
  CustomerUpdateUserMutation,
  CustomerUpdateUserMutationVariables
>

/**
 * __useCustomerUpdateUserMutation__
 *
 * To run a mutation, you first call `useCustomerUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerUpdateUserMutation, { data, loading, error }] = useCustomerUpdateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomerUpdateUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CustomerUpdateUserMutation,
    CustomerUpdateUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CustomerUpdateUserMutation,
    CustomerUpdateUserMutationVariables
  >(CustomerUpdateUserDocument, options)
}
export type CustomerUpdateUserMutationHookResult = ReturnType<
  typeof useCustomerUpdateUserMutation
>
export type CustomerUpdateUserMutationResult =
  Apollo.MutationResult<CustomerUpdateUserMutation>
export type CustomerUpdateUserMutationOptions = Apollo.BaseMutationOptions<
  CustomerUpdateUserMutation,
  CustomerUpdateUserMutationVariables
>
export const CustomerInviteUserDocument = /*#__PURE__*/ gql`
  mutation CustomerInviteUser($input: CustomerInviteUserInput) {
    CustomerInviteUser(input: $input) {
      ...CustomerUserBase
    }
  }
  ${CustomerUserBaseFragmentDoc}
`
export type CustomerInviteUserMutationFn = Apollo.MutationFunction<
  CustomerInviteUserMutation,
  CustomerInviteUserMutationVariables
>

/**
 * __useCustomerInviteUserMutation__
 *
 * To run a mutation, you first call `useCustomerInviteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerInviteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerInviteUserMutation, { data, loading, error }] = useCustomerInviteUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomerInviteUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CustomerInviteUserMutation,
    CustomerInviteUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CustomerInviteUserMutation,
    CustomerInviteUserMutationVariables
  >(CustomerInviteUserDocument, options)
}
export type CustomerInviteUserMutationHookResult = ReturnType<
  typeof useCustomerInviteUserMutation
>
export type CustomerInviteUserMutationResult =
  Apollo.MutationResult<CustomerInviteUserMutation>
export type CustomerInviteUserMutationOptions = Apollo.BaseMutationOptions<
  CustomerInviteUserMutation,
  CustomerInviteUserMutationVariables
>
export const CustomerUpdateAddressDocument = /*#__PURE__*/ gql`
  mutation CustomerUpdateAddress($input: CustomerUpdateAddressInput) {
    CustomerUpdateAddress(input: $input) {
      id
      postalCode
      country
      streetAddress
      subPremise
      city
      state
    }
  }
`
export type CustomerUpdateAddressMutationFn = Apollo.MutationFunction<
  CustomerUpdateAddressMutation,
  CustomerUpdateAddressMutationVariables
>

/**
 * __useCustomerUpdateAddressMutation__
 *
 * To run a mutation, you first call `useCustomerUpdateAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerUpdateAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerUpdateAddressMutation, { data, loading, error }] = useCustomerUpdateAddressMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomerUpdateAddressMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CustomerUpdateAddressMutation,
    CustomerUpdateAddressMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CustomerUpdateAddressMutation,
    CustomerUpdateAddressMutationVariables
  >(CustomerUpdateAddressDocument, options)
}
export type CustomerUpdateAddressMutationHookResult = ReturnType<
  typeof useCustomerUpdateAddressMutation
>
export type CustomerUpdateAddressMutationResult =
  Apollo.MutationResult<CustomerUpdateAddressMutation>
export type CustomerUpdateAddressMutationOptions = Apollo.BaseMutationOptions<
  CustomerUpdateAddressMutation,
  CustomerUpdateAddressMutationVariables
>
export const CustomerUpdateDetailsDocument = /*#__PURE__*/ gql`
  mutation CustomerUpdateDetails($input: CustomerUpdateDetailsInput) {
    CustomerUpdateDetails(input: $input) {
      id
      name
      legalName
      ein
      companyType
      industry
      description
    }
  }
`
export type CustomerUpdateDetailsMutationFn = Apollo.MutationFunction<
  CustomerUpdateDetailsMutation,
  CustomerUpdateDetailsMutationVariables
>

/**
 * __useCustomerUpdateDetailsMutation__
 *
 * To run a mutation, you first call `useCustomerUpdateDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerUpdateDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerUpdateDetailsMutation, { data, loading, error }] = useCustomerUpdateDetailsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomerUpdateDetailsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CustomerUpdateDetailsMutation,
    CustomerUpdateDetailsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CustomerUpdateDetailsMutation,
    CustomerUpdateDetailsMutationVariables
  >(CustomerUpdateDetailsDocument, options)
}
export type CustomerUpdateDetailsMutationHookResult = ReturnType<
  typeof useCustomerUpdateDetailsMutation
>
export type CustomerUpdateDetailsMutationResult =
  Apollo.MutationResult<CustomerUpdateDetailsMutation>
export type CustomerUpdateDetailsMutationOptions = Apollo.BaseMutationOptions<
  CustomerUpdateDetailsMutation,
  CustomerUpdateDetailsMutationVariables
>
export const CustomerUpdateMyUserDocument = /*#__PURE__*/ gql`
  mutation CustomerUpdateMyUser($input: CustomerUpdateMyUserInput) {
    CustomerUpdateMyUser(input: $input) {
      id
      firstName
      lastName
      phone
      jobTitle
    }
  }
`
export type CustomerUpdateMyUserMutationFn = Apollo.MutationFunction<
  CustomerUpdateMyUserMutation,
  CustomerUpdateMyUserMutationVariables
>

/**
 * __useCustomerUpdateMyUserMutation__
 *
 * To run a mutation, you first call `useCustomerUpdateMyUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerUpdateMyUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerUpdateMyUserMutation, { data, loading, error }] = useCustomerUpdateMyUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomerUpdateMyUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CustomerUpdateMyUserMutation,
    CustomerUpdateMyUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CustomerUpdateMyUserMutation,
    CustomerUpdateMyUserMutationVariables
  >(CustomerUpdateMyUserDocument, options)
}
export type CustomerUpdateMyUserMutationHookResult = ReturnType<
  typeof useCustomerUpdateMyUserMutation
>
export type CustomerUpdateMyUserMutationResult =
  Apollo.MutationResult<CustomerUpdateMyUserMutation>
export type CustomerUpdateMyUserMutationOptions = Apollo.BaseMutationOptions<
  CustomerUpdateMyUserMutation,
  CustomerUpdateMyUserMutationVariables
>
export const FindInvoiceDocument = /*#__PURE__*/ gql`
  query FindInvoice($id: String!) {
    FindInvoice(id: $id) {
      ...CustomerFindInvoice
    }
  }
  ${CustomerFindInvoiceFragmentDoc}
`

/**
 * __useFindInvoiceQuery__
 *
 * To run a query within a React component, call `useFindInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindInvoiceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFindInvoiceQuery(
  baseOptions: Apollo.QueryHookOptions<
    FindInvoiceQuery,
    FindInvoiceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<FindInvoiceQuery, FindInvoiceQueryVariables>(
    FindInvoiceDocument,
    options
  )
}
export function useFindInvoiceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FindInvoiceQuery,
    FindInvoiceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<FindInvoiceQuery, FindInvoiceQueryVariables>(
    FindInvoiceDocument,
    options
  )
}
export type FindInvoiceQueryHookResult = ReturnType<typeof useFindInvoiceQuery>
export type FindInvoiceLazyQueryHookResult = ReturnType<
  typeof useFindInvoiceLazyQuery
>
export type FindInvoiceQueryResult = Apollo.QueryResult<
  FindInvoiceQuery,
  FindInvoiceQueryVariables
>
export const CustomerInvoiceTotalsDocument = /*#__PURE__*/ gql`
  query CustomerInvoiceTotals($filters: InvoiceFilter) {
    CustomerInvoiceTotals(filters: $filters) {
      count
      amount
    }
  }
`

/**
 * __useCustomerInvoiceTotalsQuery__
 *
 * To run a query within a React component, call `useCustomerInvoiceTotalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerInvoiceTotalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerInvoiceTotalsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useCustomerInvoiceTotalsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CustomerInvoiceTotalsQuery,
    CustomerInvoiceTotalsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CustomerInvoiceTotalsQuery,
    CustomerInvoiceTotalsQueryVariables
  >(CustomerInvoiceTotalsDocument, options)
}
export function useCustomerInvoiceTotalsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CustomerInvoiceTotalsQuery,
    CustomerInvoiceTotalsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CustomerInvoiceTotalsQuery,
    CustomerInvoiceTotalsQueryVariables
  >(CustomerInvoiceTotalsDocument, options)
}
export type CustomerInvoiceTotalsQueryHookResult = ReturnType<
  typeof useCustomerInvoiceTotalsQuery
>
export type CustomerInvoiceTotalsLazyQueryHookResult = ReturnType<
  typeof useCustomerInvoiceTotalsLazyQuery
>
export type CustomerInvoiceTotalsQueryResult = Apollo.QueryResult<
  CustomerInvoiceTotalsQuery,
  CustomerInvoiceTotalsQueryVariables
>
export const CustomerInvoiceConnectionDocument = /*#__PURE__*/ gql`
  query CustomerInvoiceConnection(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $filters: InvoiceFilter
    $orderBy: InvoiceOrderBy
  ) {
    CustomerInvoiceConnection(
      after: $after
      first: $first
      before: $before
      last: $last
      filters: $filters
      orderBy: $orderBy
    ) {
      edges {
        node {
          ...CustomerInvoice
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
  ${CustomerInvoiceFragmentDoc}
`

/**
 * __useCustomerInvoiceConnectionQuery__
 *
 * To run a query within a React component, call `useCustomerInvoiceConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerInvoiceConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerInvoiceConnectionQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      filters: // value for 'filters'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useCustomerInvoiceConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CustomerInvoiceConnectionQuery,
    CustomerInvoiceConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CustomerInvoiceConnectionQuery,
    CustomerInvoiceConnectionQueryVariables
  >(CustomerInvoiceConnectionDocument, options)
}
export function useCustomerInvoiceConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CustomerInvoiceConnectionQuery,
    CustomerInvoiceConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CustomerInvoiceConnectionQuery,
    CustomerInvoiceConnectionQueryVariables
  >(CustomerInvoiceConnectionDocument, options)
}
export type CustomerInvoiceConnectionQueryHookResult = ReturnType<
  typeof useCustomerInvoiceConnectionQuery
>
export type CustomerInvoiceConnectionLazyQueryHookResult = ReturnType<
  typeof useCustomerInvoiceConnectionLazyQuery
>
export type CustomerInvoiceConnectionQueryResult = Apollo.QueryResult<
  CustomerInvoiceConnectionQuery,
  CustomerInvoiceConnectionQueryVariables
>
export const CustomerInvoiceCreateDocument = /*#__PURE__*/ gql`
  mutation CustomerInvoiceCreate($input: CustomerInvoiceCreateInput) {
    CustomerInvoiceCreate(input: $input) {
      ...CustomerInvoice
    }
  }
  ${CustomerInvoiceFragmentDoc}
`
export type CustomerInvoiceCreateMutationFn = Apollo.MutationFunction<
  CustomerInvoiceCreateMutation,
  CustomerInvoiceCreateMutationVariables
>

/**
 * __useCustomerInvoiceCreateMutation__
 *
 * To run a mutation, you first call `useCustomerInvoiceCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerInvoiceCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerInvoiceCreateMutation, { data, loading, error }] = useCustomerInvoiceCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomerInvoiceCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CustomerInvoiceCreateMutation,
    CustomerInvoiceCreateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CustomerInvoiceCreateMutation,
    CustomerInvoiceCreateMutationVariables
  >(CustomerInvoiceCreateDocument, options)
}
export type CustomerInvoiceCreateMutationHookResult = ReturnType<
  typeof useCustomerInvoiceCreateMutation
>
export type CustomerInvoiceCreateMutationResult =
  Apollo.MutationResult<CustomerInvoiceCreateMutation>
export type CustomerInvoiceCreateMutationOptions = Apollo.BaseMutationOptions<
  CustomerInvoiceCreateMutation,
  CustomerInvoiceCreateMutationVariables
>
export const CustomerPayInvoiceDocument = /*#__PURE__*/ gql`
  mutation CustomerPayInvoice(
    $invoiceID: String!
    $paymentMethod: DirectPaymentPaymentMethodInput
    $paymentDate: String
  ) {
    CustomerPayInvoice(
      invoiceID: $invoiceID
      paymentMethod: $paymentMethod
      paymentDate: $paymentDate
    ) {
      id
      message
    }
  }
`
export type CustomerPayInvoiceMutationFn = Apollo.MutationFunction<
  CustomerPayInvoiceMutation,
  CustomerPayInvoiceMutationVariables
>

/**
 * __useCustomerPayInvoiceMutation__
 *
 * To run a mutation, you first call `useCustomerPayInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerPayInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerPayInvoiceMutation, { data, loading, error }] = useCustomerPayInvoiceMutation({
 *   variables: {
 *      invoiceID: // value for 'invoiceID'
 *      paymentMethod: // value for 'paymentMethod'
 *      paymentDate: // value for 'paymentDate'
 *   },
 * });
 */
export function useCustomerPayInvoiceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CustomerPayInvoiceMutation,
    CustomerPayInvoiceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CustomerPayInvoiceMutation,
    CustomerPayInvoiceMutationVariables
  >(CustomerPayInvoiceDocument, options)
}
export type CustomerPayInvoiceMutationHookResult = ReturnType<
  typeof useCustomerPayInvoiceMutation
>
export type CustomerPayInvoiceMutationResult =
  Apollo.MutationResult<CustomerPayInvoiceMutation>
export type CustomerPayInvoiceMutationOptions = Apollo.BaseMutationOptions<
  CustomerPayInvoiceMutation,
  CustomerPayInvoiceMutationVariables
>
export const CustomerGetInvoicePdfLinkDocument = /*#__PURE__*/ gql`
  query CustomerGetInvoicePdfLink($invoiceID: String!) {
    CustomerGetInvoicePdfLink(invoiceID: $invoiceID) {
      url
      expiresAt
    }
  }
`

/**
 * __useCustomerGetInvoicePdfLinkQuery__
 *
 * To run a query within a React component, call `useCustomerGetInvoicePdfLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerGetInvoicePdfLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerGetInvoicePdfLinkQuery({
 *   variables: {
 *      invoiceID: // value for 'invoiceID'
 *   },
 * });
 */
export function useCustomerGetInvoicePdfLinkQuery(
  baseOptions: Apollo.QueryHookOptions<
    CustomerGetInvoicePdfLinkQuery,
    CustomerGetInvoicePdfLinkQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CustomerGetInvoicePdfLinkQuery,
    CustomerGetInvoicePdfLinkQueryVariables
  >(CustomerGetInvoicePdfLinkDocument, options)
}
export function useCustomerGetInvoicePdfLinkLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CustomerGetInvoicePdfLinkQuery,
    CustomerGetInvoicePdfLinkQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CustomerGetInvoicePdfLinkQuery,
    CustomerGetInvoicePdfLinkQueryVariables
  >(CustomerGetInvoicePdfLinkDocument, options)
}
export type CustomerGetInvoicePdfLinkQueryHookResult = ReturnType<
  typeof useCustomerGetInvoicePdfLinkQuery
>
export type CustomerGetInvoicePdfLinkLazyQueryHookResult = ReturnType<
  typeof useCustomerGetInvoicePdfLinkLazyQuery
>
export type CustomerGetInvoicePdfLinkQueryResult = Apollo.QueryResult<
  CustomerGetInvoicePdfLinkQuery,
  CustomerGetInvoicePdfLinkQueryVariables
>
export const CustomerGetNotificationsEnabledDocument = /*#__PURE__*/ gql`
  query CustomerGetNotificationsEnabled {
    CustomerGetNotificationsEnabled {
      id
      notificationsEnabled
    }
  }
`

/**
 * __useCustomerGetNotificationsEnabledQuery__
 *
 * To run a query within a React component, call `useCustomerGetNotificationsEnabledQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerGetNotificationsEnabledQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerGetNotificationsEnabledQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomerGetNotificationsEnabledQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CustomerGetNotificationsEnabledQuery,
    CustomerGetNotificationsEnabledQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CustomerGetNotificationsEnabledQuery,
    CustomerGetNotificationsEnabledQueryVariables
  >(CustomerGetNotificationsEnabledDocument, options)
}
export function useCustomerGetNotificationsEnabledLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CustomerGetNotificationsEnabledQuery,
    CustomerGetNotificationsEnabledQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CustomerGetNotificationsEnabledQuery,
    CustomerGetNotificationsEnabledQueryVariables
  >(CustomerGetNotificationsEnabledDocument, options)
}
export type CustomerGetNotificationsEnabledQueryHookResult = ReturnType<
  typeof useCustomerGetNotificationsEnabledQuery
>
export type CustomerGetNotificationsEnabledLazyQueryHookResult = ReturnType<
  typeof useCustomerGetNotificationsEnabledLazyQuery
>
export type CustomerGetNotificationsEnabledQueryResult = Apollo.QueryResult<
  CustomerGetNotificationsEnabledQuery,
  CustomerGetNotificationsEnabledQueryVariables
>
export const CustomerUpdateNotificationsEnabledDocument = /*#__PURE__*/ gql`
  mutation CustomerUpdateNotificationsEnabled($notificationsEnabled: Boolean!) {
    CustomerUpdateNotificationsEnabled(
      notificationsEnabled: $notificationsEnabled
    ) {
      id
      notificationsEnabled
    }
  }
`
export type CustomerUpdateNotificationsEnabledMutationFn =
  Apollo.MutationFunction<
    CustomerUpdateNotificationsEnabledMutation,
    CustomerUpdateNotificationsEnabledMutationVariables
  >

/**
 * __useCustomerUpdateNotificationsEnabledMutation__
 *
 * To run a mutation, you first call `useCustomerUpdateNotificationsEnabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerUpdateNotificationsEnabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerUpdateNotificationsEnabledMutation, { data, loading, error }] = useCustomerUpdateNotificationsEnabledMutation({
 *   variables: {
 *      notificationsEnabled: // value for 'notificationsEnabled'
 *   },
 * });
 */
export function useCustomerUpdateNotificationsEnabledMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CustomerUpdateNotificationsEnabledMutation,
    CustomerUpdateNotificationsEnabledMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CustomerUpdateNotificationsEnabledMutation,
    CustomerUpdateNotificationsEnabledMutationVariables
  >(CustomerUpdateNotificationsEnabledDocument, options)
}
export type CustomerUpdateNotificationsEnabledMutationHookResult = ReturnType<
  typeof useCustomerUpdateNotificationsEnabledMutation
>
export type CustomerUpdateNotificationsEnabledMutationResult =
  Apollo.MutationResult<CustomerUpdateNotificationsEnabledMutation>
export type CustomerUpdateNotificationsEnabledMutationOptions =
  Apollo.BaseMutationOptions<
    CustomerUpdateNotificationsEnabledMutation,
    CustomerUpdateNotificationsEnabledMutationVariables
  >
export const GetSupportPreferencesDocument = /*#__PURE__*/ gql`
  query GetSupportPreferences {
    GetSupportPreferences {
      ...SupportPreferences
    }
  }
  ${SupportPreferencesFragmentDoc}
`

/**
 * __useGetSupportPreferencesQuery__
 *
 * To run a query within a React component, call `useGetSupportPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSupportPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSupportPreferencesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSupportPreferencesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetSupportPreferencesQuery,
    GetSupportPreferencesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetSupportPreferencesQuery,
    GetSupportPreferencesQueryVariables
  >(GetSupportPreferencesDocument, options)
}
export function useGetSupportPreferencesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSupportPreferencesQuery,
    GetSupportPreferencesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetSupportPreferencesQuery,
    GetSupportPreferencesQueryVariables
  >(GetSupportPreferencesDocument, options)
}
export type GetSupportPreferencesQueryHookResult = ReturnType<
  typeof useGetSupportPreferencesQuery
>
export type GetSupportPreferencesLazyQueryHookResult = ReturnType<
  typeof useGetSupportPreferencesLazyQuery
>
export type GetSupportPreferencesQueryResult = Apollo.QueryResult<
  GetSupportPreferencesQuery,
  GetSupportPreferencesQueryVariables
>
export const FindPartnerByPaymentsPortalUrlDocument = /*#__PURE__*/ gql`
  query FindPartnerByPaymentsPortalUrl($url: String!) {
    FindPartnerByPaymentsPortalUrl(url: $url) {
      ...CustomerPartner
    }
  }
  ${CustomerPartnerFragmentDoc}
`

/**
 * __useFindPartnerByPaymentsPortalUrlQuery__
 *
 * To run a query within a React component, call `useFindPartnerByPaymentsPortalUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindPartnerByPaymentsPortalUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindPartnerByPaymentsPortalUrlQuery({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function useFindPartnerByPaymentsPortalUrlQuery(
  baseOptions: Apollo.QueryHookOptions<
    FindPartnerByPaymentsPortalUrlQuery,
    FindPartnerByPaymentsPortalUrlQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    FindPartnerByPaymentsPortalUrlQuery,
    FindPartnerByPaymentsPortalUrlQueryVariables
  >(FindPartnerByPaymentsPortalUrlDocument, options)
}
export function useFindPartnerByPaymentsPortalUrlLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FindPartnerByPaymentsPortalUrlQuery,
    FindPartnerByPaymentsPortalUrlQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    FindPartnerByPaymentsPortalUrlQuery,
    FindPartnerByPaymentsPortalUrlQueryVariables
  >(FindPartnerByPaymentsPortalUrlDocument, options)
}
export type FindPartnerByPaymentsPortalUrlQueryHookResult = ReturnType<
  typeof useFindPartnerByPaymentsPortalUrlQuery
>
export type FindPartnerByPaymentsPortalUrlLazyQueryHookResult = ReturnType<
  typeof useFindPartnerByPaymentsPortalUrlLazyQuery
>
export type FindPartnerByPaymentsPortalUrlQueryResult = Apollo.QueryResult<
  FindPartnerByPaymentsPortalUrlQuery,
  FindPartnerByPaymentsPortalUrlQueryVariables
>
export const GetPartnerIdByLoginChallengeDocument = /*#__PURE__*/ gql`
  query GetPartnerIdByLoginChallenge($loginChallenge: String!) {
    GetPartnerIdByLoginChallenge(loginChallenge: $loginChallenge)
  }
`

/**
 * __useGetPartnerIdByLoginChallengeQuery__
 *
 * To run a query within a React component, call `useGetPartnerIdByLoginChallengeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartnerIdByLoginChallengeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartnerIdByLoginChallengeQuery({
 *   variables: {
 *      loginChallenge: // value for 'loginChallenge'
 *   },
 * });
 */
export function useGetPartnerIdByLoginChallengeQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetPartnerIdByLoginChallengeQuery,
    GetPartnerIdByLoginChallengeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetPartnerIdByLoginChallengeQuery,
    GetPartnerIdByLoginChallengeQueryVariables
  >(GetPartnerIdByLoginChallengeDocument, options)
}
export function useGetPartnerIdByLoginChallengeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPartnerIdByLoginChallengeQuery,
    GetPartnerIdByLoginChallengeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetPartnerIdByLoginChallengeQuery,
    GetPartnerIdByLoginChallengeQueryVariables
  >(GetPartnerIdByLoginChallengeDocument, options)
}
export type GetPartnerIdByLoginChallengeQueryHookResult = ReturnType<
  typeof useGetPartnerIdByLoginChallengeQuery
>
export type GetPartnerIdByLoginChallengeLazyQueryHookResult = ReturnType<
  typeof useGetPartnerIdByLoginChallengeLazyQuery
>
export type GetPartnerIdByLoginChallengeQueryResult = Apollo.QueryResult<
  GetPartnerIdByLoginChallengeQuery,
  GetPartnerIdByLoginChallengeQueryVariables
>
export const GetPartnerByIdDocument = /*#__PURE__*/ gql`
  query GetPartnerById($partnerId: String!) {
    GetPartnerById(partnerId: $partnerId) {
      ...PartnerWhitelabel
    }
  }
  ${PartnerWhitelabelFragmentDoc}
`

/**
 * __useGetPartnerByIdQuery__
 *
 * To run a query within a React component, call `useGetPartnerByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartnerByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartnerByIdQuery({
 *   variables: {
 *      partnerId: // value for 'partnerId'
 *   },
 * });
 */
export function useGetPartnerByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetPartnerByIdQuery,
    GetPartnerByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetPartnerByIdQuery, GetPartnerByIdQueryVariables>(
    GetPartnerByIdDocument,
    options
  )
}
export function useGetPartnerByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPartnerByIdQuery,
    GetPartnerByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetPartnerByIdQuery, GetPartnerByIdQueryVariables>(
    GetPartnerByIdDocument,
    options
  )
}
export type GetPartnerByIdQueryHookResult = ReturnType<
  typeof useGetPartnerByIdQuery
>
export type GetPartnerByIdLazyQueryHookResult = ReturnType<
  typeof useGetPartnerByIdLazyQuery
>
export type GetPartnerByIdQueryResult = Apollo.QueryResult<
  GetPartnerByIdQuery,
  GetPartnerByIdQueryVariables
>
export const CustomerGetForwardingConfigDocument = /*#__PURE__*/ gql`
  query CustomerGetForwardingConfig {
    CustomerGetForwardingConfig {
      coverDirectPaymentFees
      coverFeeConfig {
        coverCardMethodFee
      }
      partner {
        ...CustomerPartnerBase
      }
      customer {
        id
      }
    }
  }
  ${CustomerPartnerBaseFragmentDoc}
`

/**
 * __useCustomerGetForwardingConfigQuery__
 *
 * To run a query within a React component, call `useCustomerGetForwardingConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerGetForwardingConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerGetForwardingConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomerGetForwardingConfigQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CustomerGetForwardingConfigQuery,
    CustomerGetForwardingConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CustomerGetForwardingConfigQuery,
    CustomerGetForwardingConfigQueryVariables
  >(CustomerGetForwardingConfigDocument, options)
}
export function useCustomerGetForwardingConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CustomerGetForwardingConfigQuery,
    CustomerGetForwardingConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CustomerGetForwardingConfigQuery,
    CustomerGetForwardingConfigQueryVariables
  >(CustomerGetForwardingConfigDocument, options)
}
export type CustomerGetForwardingConfigQueryHookResult = ReturnType<
  typeof useCustomerGetForwardingConfigQuery
>
export type CustomerGetForwardingConfigLazyQueryHookResult = ReturnType<
  typeof useCustomerGetForwardingConfigLazyQuery
>
export type CustomerGetForwardingConfigQueryResult = Apollo.QueryResult<
  CustomerGetForwardingConfigQuery,
  CustomerGetForwardingConfigQueryVariables
>
export const CustomerGetPartnerAutopayConfigDocument = /*#__PURE__*/ gql`
  query CustomerGetPartnerAutopayConfig {
    CustomerGetPartnerAutopayConfig {
      id
      allowCustomerEdit
    }
  }
`

/**
 * __useCustomerGetPartnerAutopayConfigQuery__
 *
 * To run a query within a React component, call `useCustomerGetPartnerAutopayConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerGetPartnerAutopayConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerGetPartnerAutopayConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomerGetPartnerAutopayConfigQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CustomerGetPartnerAutopayConfigQuery,
    CustomerGetPartnerAutopayConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CustomerGetPartnerAutopayConfigQuery,
    CustomerGetPartnerAutopayConfigQueryVariables
  >(CustomerGetPartnerAutopayConfigDocument, options)
}
export function useCustomerGetPartnerAutopayConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CustomerGetPartnerAutopayConfigQuery,
    CustomerGetPartnerAutopayConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CustomerGetPartnerAutopayConfigQuery,
    CustomerGetPartnerAutopayConfigQueryVariables
  >(CustomerGetPartnerAutopayConfigDocument, options)
}
export type CustomerGetPartnerAutopayConfigQueryHookResult = ReturnType<
  typeof useCustomerGetPartnerAutopayConfigQuery
>
export type CustomerGetPartnerAutopayConfigLazyQueryHookResult = ReturnType<
  typeof useCustomerGetPartnerAutopayConfigLazyQuery
>
export type CustomerGetPartnerAutopayConfigQueryResult = Apollo.QueryResult<
  CustomerGetPartnerAutopayConfigQuery,
  CustomerGetPartnerAutopayConfigQueryVariables
>
export const CustomerGetPaymentConfigDocument = /*#__PURE__*/ gql`
  query CustomerGetPaymentConfig {
    CustomerGetPaymentConfig {
      ...CustomerPaymentConfig
    }
  }
  ${CustomerPaymentConfigFragmentDoc}
`

/**
 * __useCustomerGetPaymentConfigQuery__
 *
 * To run a query within a React component, call `useCustomerGetPaymentConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerGetPaymentConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerGetPaymentConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomerGetPaymentConfigQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CustomerGetPaymentConfigQuery,
    CustomerGetPaymentConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CustomerGetPaymentConfigQuery,
    CustomerGetPaymentConfigQueryVariables
  >(CustomerGetPaymentConfigDocument, options)
}
export function useCustomerGetPaymentConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CustomerGetPaymentConfigQuery,
    CustomerGetPaymentConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CustomerGetPaymentConfigQuery,
    CustomerGetPaymentConfigQueryVariables
  >(CustomerGetPaymentConfigDocument, options)
}
export type CustomerGetPaymentConfigQueryHookResult = ReturnType<
  typeof useCustomerGetPaymentConfigQuery
>
export type CustomerGetPaymentConfigLazyQueryHookResult = ReturnType<
  typeof useCustomerGetPaymentConfigLazyQuery
>
export type CustomerGetPaymentConfigQueryResult = Apollo.QueryResult<
  CustomerGetPaymentConfigQuery,
  CustomerGetPaymentConfigQueryVariables
>
export const CustomerChangePaymentConfigDocument = /*#__PURE__*/ gql`
  mutation CustomerChangePaymentConfig(
    $paymentConfig: PaymentCompanyConfigUpdateInput!
  ) {
    CustomerChangePaymentConfig(paymentConfig: $paymentConfig)
  }
`
export type CustomerChangePaymentConfigMutationFn = Apollo.MutationFunction<
  CustomerChangePaymentConfigMutation,
  CustomerChangePaymentConfigMutationVariables
>

/**
 * __useCustomerChangePaymentConfigMutation__
 *
 * To run a mutation, you first call `useCustomerChangePaymentConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerChangePaymentConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerChangePaymentConfigMutation, { data, loading, error }] = useCustomerChangePaymentConfigMutation({
 *   variables: {
 *      paymentConfig: // value for 'paymentConfig'
 *   },
 * });
 */
export function useCustomerChangePaymentConfigMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CustomerChangePaymentConfigMutation,
    CustomerChangePaymentConfigMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CustomerChangePaymentConfigMutation,
    CustomerChangePaymentConfigMutationVariables
  >(CustomerChangePaymentConfigDocument, options)
}
export type CustomerChangePaymentConfigMutationHookResult = ReturnType<
  typeof useCustomerChangePaymentConfigMutation
>
export type CustomerChangePaymentConfigMutationResult =
  Apollo.MutationResult<CustomerChangePaymentConfigMutation>
export type CustomerChangePaymentConfigMutationOptions =
  Apollo.BaseMutationOptions<
    CustomerChangePaymentConfigMutation,
    CustomerChangePaymentConfigMutationVariables
  >
export const CustomerPaymentConnectionDocument = /*#__PURE__*/ gql`
  query CustomerPaymentConnection(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $paymentFilter: PaymentFilter
    $orderBy: PaymentOrder
  ) {
    CustomerPaymentConnection(
      after: $after
      first: $first
      before: $before
      last: $last
      paymentFilter: $paymentFilter
      orderBy: $orderBy
    ) {
      edges {
        node {
          ...CustomerPayment
        }
        cursor
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
  ${CustomerPaymentFragmentDoc}
`

/**
 * __useCustomerPaymentConnectionQuery__
 *
 * To run a query within a React component, call `useCustomerPaymentConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerPaymentConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerPaymentConnectionQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      paymentFilter: // value for 'paymentFilter'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useCustomerPaymentConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CustomerPaymentConnectionQuery,
    CustomerPaymentConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CustomerPaymentConnectionQuery,
    CustomerPaymentConnectionQueryVariables
  >(CustomerPaymentConnectionDocument, options)
}
export function useCustomerPaymentConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CustomerPaymentConnectionQuery,
    CustomerPaymentConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CustomerPaymentConnectionQuery,
    CustomerPaymentConnectionQueryVariables
  >(CustomerPaymentConnectionDocument, options)
}
export type CustomerPaymentConnectionQueryHookResult = ReturnType<
  typeof useCustomerPaymentConnectionQuery
>
export type CustomerPaymentConnectionLazyQueryHookResult = ReturnType<
  typeof useCustomerPaymentConnectionLazyQuery
>
export type CustomerPaymentConnectionQueryResult = Apollo.QueryResult<
  CustomerPaymentConnectionQuery,
  CustomerPaymentConnectionQueryVariables
>
export const GetUserEmailByKratosIdentityDocument = /*#__PURE__*/ gql`
  query GetUserEmailByKratosIdentity {
    GetUserEmailByKratosIdentity
  }
`

/**
 * __useGetUserEmailByKratosIdentityQuery__
 *
 * To run a query within a React component, call `useGetUserEmailByKratosIdentityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserEmailByKratosIdentityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserEmailByKratosIdentityQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserEmailByKratosIdentityQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetUserEmailByKratosIdentityQuery,
    GetUserEmailByKratosIdentityQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetUserEmailByKratosIdentityQuery,
    GetUserEmailByKratosIdentityQueryVariables
  >(GetUserEmailByKratosIdentityDocument, options)
}
export function useGetUserEmailByKratosIdentityLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUserEmailByKratosIdentityQuery,
    GetUserEmailByKratosIdentityQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetUserEmailByKratosIdentityQuery,
    GetUserEmailByKratosIdentityQueryVariables
  >(GetUserEmailByKratosIdentityDocument, options)
}
export type GetUserEmailByKratosIdentityQueryHookResult = ReturnType<
  typeof useGetUserEmailByKratosIdentityQuery
>
export type GetUserEmailByKratosIdentityLazyQueryHookResult = ReturnType<
  typeof useGetUserEmailByKratosIdentityLazyQuery
>
export type GetUserEmailByKratosIdentityQueryResult = Apollo.QueryResult<
  GetUserEmailByKratosIdentityQuery,
  GetUserEmailByKratosIdentityQueryVariables
>
export const GetCustomerUsersDocument = /*#__PURE__*/ gql`
  query GetCustomerUsers {
    GetCustomerUsers {
      ...CustomerUserInfoData
    }
  }
  ${CustomerUserInfoDataFragmentDoc}
`

/**
 * __useGetCustomerUsersQuery__
 *
 * To run a query within a React component, call `useGetCustomerUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCustomerUsersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCustomerUsersQuery,
    GetCustomerUsersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCustomerUsersQuery, GetCustomerUsersQueryVariables>(
    GetCustomerUsersDocument,
    options
  )
}
export function useGetCustomerUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCustomerUsersQuery,
    GetCustomerUsersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetCustomerUsersQuery,
    GetCustomerUsersQueryVariables
  >(GetCustomerUsersDocument, options)
}
export type GetCustomerUsersQueryHookResult = ReturnType<
  typeof useGetCustomerUsersQuery
>
export type GetCustomerUsersLazyQueryHookResult = ReturnType<
  typeof useGetCustomerUsersLazyQuery
>
export type GetCustomerUsersQueryResult = Apollo.QueryResult<
  GetCustomerUsersQuery,
  GetCustomerUsersQueryVariables
>
export const GetUserInfoDocument = /*#__PURE__*/ gql`
  query GetUserInfo {
    GetUserInfo {
      id
      userType
      users {
        ...CustomerUserInfoData
      }
    }
  }
  ${CustomerUserInfoDataFragmentDoc}
`

/**
 * __useGetUserInfoQuery__
 *
 * To run a query within a React component, call `useGetUserInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserInfoQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetUserInfoQuery,
    GetUserInfoQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetUserInfoQuery, GetUserInfoQueryVariables>(
    GetUserInfoDocument,
    options
  )
}
export function useGetUserInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUserInfoQuery,
    GetUserInfoQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetUserInfoQuery, GetUserInfoQueryVariables>(
    GetUserInfoDocument,
    options
  )
}
export type GetUserInfoQueryHookResult = ReturnType<typeof useGetUserInfoQuery>
export type GetUserInfoLazyQueryHookResult = ReturnType<
  typeof useGetUserInfoLazyQuery
>
export type GetUserInfoQueryResult = Apollo.QueryResult<
  GetUserInfoQuery,
  GetUserInfoQueryVariables
>
export const GetUserTypeDocument = /*#__PURE__*/ gql`
  query GetUserType {
    GetUserInfo {
      id
      userType
    }
  }
`

/**
 * __useGetUserTypeQuery__
 *
 * To run a query within a React component, call `useGetUserTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserTypeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserTypeQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetUserTypeQuery,
    GetUserTypeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetUserTypeQuery, GetUserTypeQueryVariables>(
    GetUserTypeDocument,
    options
  )
}
export function useGetUserTypeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUserTypeQuery,
    GetUserTypeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetUserTypeQuery, GetUserTypeQueryVariables>(
    GetUserTypeDocument,
    options
  )
}
export type GetUserTypeQueryHookResult = ReturnType<typeof useGetUserTypeQuery>
export type GetUserTypeLazyQueryHookResult = ReturnType<
  typeof useGetUserTypeLazyQuery
>
export type GetUserTypeQueryResult = Apollo.QueryResult<
  GetUserTypeQuery,
  GetUserTypeQueryVariables
>
export const UserHasKratosIdentityDocument = /*#__PURE__*/ gql`
  query UserHasKratosIdentity($identifier: String!) {
    UserHasKratosIdentity(identifier: $identifier)
  }
`

/**
 * __useUserHasKratosIdentityQuery__
 *
 * To run a query within a React component, call `useUserHasKratosIdentityQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserHasKratosIdentityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserHasKratosIdentityQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useUserHasKratosIdentityQuery(
  baseOptions: Apollo.QueryHookOptions<
    UserHasKratosIdentityQuery,
    UserHasKratosIdentityQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    UserHasKratosIdentityQuery,
    UserHasKratosIdentityQueryVariables
  >(UserHasKratosIdentityDocument, options)
}
export function useUserHasKratosIdentityLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserHasKratosIdentityQuery,
    UserHasKratosIdentityQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    UserHasKratosIdentityQuery,
    UserHasKratosIdentityQueryVariables
  >(UserHasKratosIdentityDocument, options)
}
export type UserHasKratosIdentityQueryHookResult = ReturnType<
  typeof useUserHasKratosIdentityQuery
>
export type UserHasKratosIdentityLazyQueryHookResult = ReturnType<
  typeof useUserHasKratosIdentityLazyQuery
>
export type UserHasKratosIdentityQueryResult = Apollo.QueryResult<
  UserHasKratosIdentityQuery,
  UserHasKratosIdentityQueryVariables
>
export const GetUserKratosCredentialsDocument = /*#__PURE__*/ gql`
  query GetUserKratosCredentials($identifier: String!) {
    GetUserKratosCredentials(identifier: $identifier) {
      credentials
    }
  }
`

/**
 * __useGetUserKratosCredentialsQuery__
 *
 * To run a query within a React component, call `useGetUserKratosCredentialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserKratosCredentialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserKratosCredentialsQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useGetUserKratosCredentialsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetUserKratosCredentialsQuery,
    GetUserKratosCredentialsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetUserKratosCredentialsQuery,
    GetUserKratosCredentialsQueryVariables
  >(GetUserKratosCredentialsDocument, options)
}
export function useGetUserKratosCredentialsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUserKratosCredentialsQuery,
    GetUserKratosCredentialsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetUserKratosCredentialsQuery,
    GetUserKratosCredentialsQueryVariables
  >(GetUserKratosCredentialsDocument, options)
}
export type GetUserKratosCredentialsQueryHookResult = ReturnType<
  typeof useGetUserKratosCredentialsQuery
>
export type GetUserKratosCredentialsLazyQueryHookResult = ReturnType<
  typeof useGetUserKratosCredentialsLazyQuery
>
export type GetUserKratosCredentialsQueryResult = Apollo.QueryResult<
  GetUserKratosCredentialsQuery,
  GetUserKratosCredentialsQueryVariables
>
export const GraphQLOperations = {
  Query: {
    OAuth2Url: 'OAuth2Url',
    CustomerAutopayRuleConnection: 'CustomerAutopayRuleConnection',
    CustomerInvoiceBnplTotals: 'CustomerInvoiceBnplTotals',
    CustomerInvoiceBnplConnection: 'CustomerInvoiceBnplConnection',
    CustomerListBankingIntegrations: 'CustomerListBankingIntegrations',
    CustomerGetLinkToken: 'CustomerGetLinkToken',
    CustomerListCards: 'CustomerListCards',
    CustomerGetCardPubKey: 'CustomerGetCardPubKey',
    CustomerGetCardFee: 'CustomerGetCardFee',
    CustomerGetCardFees: 'CustomerGetCardFees',
    GetUserCustomers: 'GetUserCustomers',
    GetCustomerUserTeams: 'GetCustomerUserTeams',
    CustomerUserConnection: 'CustomerUserConnection',
    FindInvoice: 'FindInvoice',
    CustomerInvoiceTotals: 'CustomerInvoiceTotals',
    CustomerInvoiceConnection: 'CustomerInvoiceConnection',
    CustomerGetInvoicePdfLink: 'CustomerGetInvoicePdfLink',
    CustomerGetNotificationsEnabled: 'CustomerGetNotificationsEnabled',
    GetSupportPreferences: 'GetSupportPreferences',
    FindPartnerByPaymentsPortalUrl: 'FindPartnerByPaymentsPortalUrl',
    GetPartnerIdByLoginChallenge: 'GetPartnerIdByLoginChallenge',
    GetPartnerById: 'GetPartnerById',
    CustomerGetForwardingConfig: 'CustomerGetForwardingConfig',
    CustomerGetPartnerAutopayConfig: 'CustomerGetPartnerAutopayConfig',
    CustomerGetPaymentConfig: 'CustomerGetPaymentConfig',
    CustomerPaymentConnection: 'CustomerPaymentConnection',
    GetUserEmailByKratosIdentity: 'GetUserEmailByKratosIdentity',
    GetCustomerUsers: 'GetCustomerUsers',
    GetUserInfo: 'GetUserInfo',
    GetUserType: 'GetUserType',
    UserHasKratosIdentity: 'UserHasKratosIdentity',
    GetUserKratosCredentials: 'GetUserKratosCredentials'
  },
  Mutation: {
    OAuth2Exchange: 'OAuth2Exchange',
    OAuth2Refresh: 'OAuth2Refresh',
    CustomerCreateAutopayRule: 'CustomerCreateAutopayRule',
    CustomerAutopayExcludedCustomerCreate:
      'CustomerAutopayExcludedCustomerCreate',
    CustomerBNPLOfferCreate: 'CustomerBNPLOfferCreate',
    GetRate: 'GetRate',
    CustomerArchiveAccount: 'CustomerArchiveAccount',
    CustomerAddManualBankingConnection: 'CustomerAddManualBankingConnection',
    CustomerAddPlaidConnection: 'CustomerAddPlaidConnection',
    CustomerCreateCard: 'CustomerCreateCard',
    CustomerDeleteCard: 'CustomerDeleteCard',
    CustomerModernBancGenerateSerializedToken:
      'CustomerModernBancGenerateSerializedToken',
    CustomerRequestAccess: 'CustomerRequestAccess',
    CustomerFinishOnboarding: 'CustomerFinishOnboarding',
    CustomerDeleteUser: 'CustomerDeleteUser',
    CustomerUpdateUser: 'CustomerUpdateUser',
    CustomerInviteUser: 'CustomerInviteUser',
    CustomerUpdateAddress: 'CustomerUpdateAddress',
    CustomerUpdateDetails: 'CustomerUpdateDetails',
    CustomerUpdateMyUser: 'CustomerUpdateMyUser',
    CustomerInvoiceCreate: 'CustomerInvoiceCreate',
    CustomerPayInvoice: 'CustomerPayInvoice',
    CustomerUpdateNotificationsEnabled: 'CustomerUpdateNotificationsEnabled',
    CustomerChangePaymentConfig: 'CustomerChangePaymentConfig'
  },
  Fragment: {
    Token: 'Token',
    CustomerAutopayRules: 'CustomerAutopayRules',
    BNPLRate: 'BNPLRate',
    CustomerBank: 'CustomerBank',
    CustomerBankAccount: 'CustomerBankAccount',
    CustomerCreditCard: 'CustomerCreditCard',
    CustomerUserBase: 'CustomerUserBase',
    CustomerListUser: 'CustomerListUser',
    CustomerBasic: 'CustomerBasic',
    CustomerInvoice: 'CustomerInvoice',
    CustomerFindInvoice: 'CustomerFindInvoice',
    CustomerInvoiceInstallment: 'CustomerInvoiceInstallment',
    CustomerInstallmentPayment: 'CustomerInstallmentPayment',
    CustomerBNPLOffer: 'CustomerBNPLOffer',
    PartnerWhitelabel: 'PartnerWhitelabel',
    CustomerPartnerBase: 'CustomerPartnerBase',
    CustomerPartner: 'CustomerPartner',
    SupportPreferences: 'SupportPreferences',
    CustomerPaymentConfig: 'CustomerPaymentConfig',
    CustomerPayment: 'CustomerPayment',
    CustomerUserInfoData: 'CustomerUserInfoData',
    CustomerInfo: 'CustomerInfo'
  }
}
